import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { agentActions } from '../../../actions';
import { report, lossAssDashboard, reportPreviewActions } from '../../actions';
import moment from 'moment';
import {
    Table,
    DatePicker,
    Select,
    Input,
    InputNumber,
    Button,
    message,
    Modal,
    Collapse,
    Tag,
    Checkbox,
    Row,
    Col,
    Form,
    Drawer,
    Space,
    Dropdown,
    Menu,
    Radio
} from 'antd';
import t from '../../../localization';
import { policyTypeList } from '../../../constants/policy';
import secondCities from '../../../constants/secondCities';
import {
    reportStateList,
    finishedStateList,
    lossStateList,
    lossSubStateList,
    accidentFirstTypeList,
    accidentSecondTypeList,
    coopTaskTypeList,
    complaintLevelList,
    elemeAuditStatusList,
    QIANHAIelemeAuditStatusList,
    casualtyList,
    caseStatusList,
    recommendWithdrawStatus
} from '../../../constants/report';
import { overOrgQueryReportsPermission } from '../../../utils/agent';
import { getExportPermission } from '../../../service/account';
import { downloadFile } from '../../../utils/index';
import RemoteSearchSelect from '@base-components/RemoteSearchSelect/RemoteSearchSelect.js';
import ImportExpressPackages from './ImportExpressPackages';
import ImportAssignmentReport from './ImportAssignmentReport';
import { getSearchParams } from './utils';
import {
    getOrganizations,
    getPlansByTenant,
    getMajorCaseTypes,
    getActiveEmployer,
    getRiskLevels,
    getConstantTypes,
    getProductTypes,
    getRiskTypes,
    exportReportDetail,
    exportReportData,
    exportExpressMaterial,
    getReportInfo,
    getReportList,
    getRiskProducts,
    getAssignAgents,
    assignToAgent,
    queryAssignToAgentAll,
    assignToAgentAll,
    assignToAgentByFile
} from '../../../service/report.js';
import { DISPATCH_PERMISSION } from '../../../constants/report';
import './style.scss';

const { Option } = Select,
    { Search } = Input,
    { RangePicker } = DatePicker;
const { isExport } = process.env;

const provinceList = secondCities.map((item) => ({ value: item.value, label: item.label }));

const disabledDate = function (current, minDate) {
    if (minDate && current && current < moment(minDate)) {
        return true;
    }
    return current && current > moment();
};

const agentStatusNames = {
    online: '在线',
    offline: '离线',
    on: '上班',
    off: '下班'
};
const agentStatusCalssNames = {
    online: 'agent-status-online',
    offline: 'agent-status-offline',
    on: 'agent-status-serviceon',
    off: 'agent-status-serviceoff'
};
// 处理日期区间的时间，返回两个值，开始时间为起始日期的0点，结束时间为结束日期的23点59分59秒
const splitTime = (key, rangeTime) => {
    if (key && rangeTime && Array.isArray(rangeTime)) {
        let [startTime, endTime] = rangeTime;
        startTime = startTime ? startTime.startOf('day').unix() : '';
        endTime = endTime ? endTime.endOf('day').unix() : '';
        return startTime && endTime ? { [key]: [startTime, endTime] } : {};
    }
    return {};
};

const recommendWithdrawStatusOptions = Object.keys(recommendWithdrawStatus).reduce(
    (pre, cur) => [...pre, { label: recommendWithdrawStatus[cur], value: cur }],
    []
);

class ReportPage extends Component {
    constructor(props) {
        super(props);
        props.cacheLifecycles.didCache(this.componentDidCache);
        props.cacheLifecycles.didRecover(this.componentDidRecover);
        const tenantCode = props.currentAgent.tenant.code;
        this.state = {
            loading: false,
            pageSize: 10,
            searchTenant: undefined,
            searchOrgAccount: undefined,
            isDownloadFile: false,
            // 导入包裹弹框
            importExpressVisible: false,
            // 导入指派弹框
            importAssignmentVisible: false,
            isDownloadExpressMaterial: false,
            isDownloadDetailFile: false,
            selectedRowKeys: [],
            selectedRows: [],
            assignReportLoading: false,
            list: [],
            orgAccount: undefined,
            majorCaseTypes: [],
            majorCaseType: [],
            organization: [],
            levels: [],
            activeEmployer: [],
            productTypeList: [],
            plans: [],
            reportTirePositions: [],
            reportVehicleUsages: [],
            reportTireDamageTypes: [],
            riskTypes: [],
            riskProducts: [],
            accountAccess: '',
            reportReceipts: {
                list: [],
                columns: [],
                count: 0
            },
            agents: [],
            filterVisible: false,
            isFilter: false,
            // 人保达达保司状态
            PICCCaseStatusList: [],
            // 圆通保司状态
            YTCaseStatusList: [],
            // 大家雇主险保司状态
            DAJIACaseStatusList: [],
            query: {
                order: '',
                kwType: [21].includes(tenantCode) ? 'reportId' : 'flowId',
                orderBy: '',
                keyWord: ''
            },
            // 可指派的坐席
            assignableAgents: [],
            // 客服组外的坐席
            outsideAgents: [],
            // 可指派的坐席（备份数据，作为筛选项来源）
            fullAssignableAgents: [],
            // 可指派的坐席 客服组外的坐席（备份数据，作为筛选项来源）
            fullOutsideAgents: [],
            // 操作的指派信息
            selectedAssignmentInfo: {
                // 勾选的任务类型
                selectedTypes: [1],
                // 选择的指派机构
                selectedOrgId: undefined,
                // 选择的指派坐席
                selectedAgentId: ''
            },
            assignModalVisible: false,
            // assign多选指派；assignAll全部指派；assignByFile按照文件导入指派
            assignType: undefined,
            assignInfo: {
                defLossTaskCount: 0,
                reportCount: 0,
                orgAccounts: [],
                fileId: ''
            },
            exportPermission: false
        };
    }
    searchForm = React.createRef();
    filterForm = React.createRef();
    initialValues = {};
    defaultValues = {};
    timer = null;

    componentDidCache = () => {
        // console.log('List cached')
    };

    componentDidRecover = () => {
        console.log('componentDidRecover');
        // console.log('List recovered')
    };

    componentDidMount() {
        console.log('componentDidMount');
        this.initialization();
        this.queryExportPermission();
    }
    componentDidUpdate(prevProps, state) {
        // 当点击待邮寄icon时，需要重置搜索Form条件
        if (this.props.location.state?.resetQuery && prevProps.location.state?.resetQuery !== this.props.location.state?.resetQuery) {
            console.log('componentDidUpdate')
            this.initialization();
        }
    }
    // 更改搜索类型
    onChangeKwType = (value) => {
        this.setState({
            query: { ...this.state.query, kwType: value }
        });
    };
    getMajorCaseTypes = (tenantCode = '') => {
        getMajorCaseTypes({
            tenantCode
        })
            .then((res) => {
                this.setState({
                    majorCaseTypes: res.result
                });
            })
            .catch((err) => {
                message.error(
                    err.message || '请求/api/lossAss/report/majorCaseTypes?tenantCode=失败'
                );
            });
    };
    // 获取常量数据
    getConstant = (constantType) => {
        getConstantTypes(constantType)
            .then((res) => {
                this.setState({
                    [constantType]: res.result
                });
            })
            .catch((err) => {
                message.error(err.message);
            });
    };
    //查询产品类型
    getProductTypeOfYuantong = () => {
        const { currentAgent } = this.props;
        getProductTypes({
            agentId: currentAgent._id
        })
            .then((res) => {
                this.setState({
                    productTypeList: res.result
                });
            })
            .catch((err) => {
                message.error(err.message || '请求/api/lossAss/yuantong/productType失败');
            });
    };

    //查询产品类型
    getProductType = () => {
        const { currentAgent } = this.props;
        getRiskProducts({
            tenantId: currentAgent?.tenant?._id
        }).then((res) => {
            this.setState({
                riskProducts: res.result
            });
        })
        .catch((err) => {
            message.error(err.message);
        });
    };

    queryExportPermission = () => {
        getExportPermission().then(res => {
            // console.log('per', res.result.exportPermission)
            this.setState({
                exportPermission: res.result.exportPermission
            })
        })
    }

    onChange = (field, value) => {
        this.setState({
            [field]: value
        });
    };
    initialization() {
        const { currentAgent = {}, location } = this.props,
            { tenant = {}, orgAccount = {}, agentRole = {}, expressOrgs = [] } = currentAgent;
        const orgAccountId = (orgAccount && orgAccount._id) || '';
        const accountAccess = agentRole.level || '';
        const searchTenant = tenant._id || '';
        const searchOrgAccount = ['1', '2'].includes(accountAccess) ? [orgAccountId] : [];
        const agentId = ['1'].includes(accountAccess) ? currentAgent._id : undefined;
        const caseStatusMap = caseStatusList.reduce(
            (pre, cur) => ({ ...pre, [cur.value]: cur.list }),
            {}
        );

        // isResetQuery，判断页面是否是邮寄按钮跳转进来
        const isResetQuery = location.state && location.state.hasOwnProperty('resetQuery');

        this.defaultValues = {
            daysType: 'today',
            createdDate: [
                moment(moment.unix(moment().startOf('day').unix())),
                moment(moment.unix(moment().unix()))
            ],
            searchTenant,
            state: [],
            subState: [],
            searchOrgAccount: searchOrgAccount || [],
            defLossState: [],
            accidentFirstType: '',
            agentId: agentId || undefined,
            clientReviewAgentId: undefined,
            defLossAgentId: undefined,
            customerAgentId: undefined,
            majorCaseType: [],
            coopTaskTypes: [],
            complaintLevels: [],
            riskLevelId: [],
            coreProductCodes: [],
            claimState: undefined
        };
        // 点击更多筛选，需将此选项重置给更多筛选Form
        this.initialValues = isResetQuery ? {
            ...this.defaultValues,
            daysType: undefined,
            createdDate: [],
            searchOrgAccount: [],
            agentId: undefined,
            expressMaterialStatus: ['toCheck'],
        } : this.defaultValues;

        this.searchForm.current.resetFields();
        // 从待邮寄icon跳转过来，需多处理几个字段
        this.searchForm.current.setFieldsValue(this.initialValues);

        // 筛选Form和更多筛选Form都需重置，部分筛选条件会隐藏在更多筛选里，在搜索时用得到
        if (this.filterForm.current) {
            this.filterForm.current.resetFields();
            // 从待邮寄icon跳转过来，需多处理几个字段
            this.filterForm.current.setFieldsValue(this.initialValues);
        }

        this.setState(
            {
                searchTenant,
                searchOrgAccount,
                agentId,
                PICCCaseStatusList: caseStatusMap[tenant.code] || [],
                YTCaseStatusList: caseStatusMap[tenant.code] || [],
                DAJIACaseStatusList: caseStatusMap[tenant.code] || [],
                accountAccess,
                query: {
                    order: '',
                    kwType: [21].includes(tenant.code) ? 'reportId' : 'flowId',
                    orderBy: '',
                    keyWord: ''
                }
            }
        );

        this.getOrganization().then((orgList) => {
            // 邮寄票据入口，跳转业务中心，需筛选权限内机构，若当前账号所在机构开启跨机构查询，则显示所有权限内的机构；若未开启跨机构查询，则只显示当前机构
            if (isResetQuery) {
                if (overOrgQueryReportsPermission(currentAgent)) {
                    const orgsByPermission = expressOrgs.filter(orgId => orgList.map(org => org._id).includes(orgId));
                    this.searchForm.current.setFieldsValue({
                        searchOrgAccount: orgsByPermission
                    });
                    // 筛选Form和更多筛选Form都需重置，部分筛选条件会隐藏在更多筛选里，在搜索时用得到
                    if (this.filterForm.current) {
                        this.filterForm.current.setFieldsValue({
                            searchOrgAccount: orgsByPermission
                        });
                    }
                } else {
                    this.searchForm.current.setFieldsValue({
                        searchOrgAccount
                    })
                    if (this.filterForm.current) {
                        this.filterForm.current.setFieldsValue({
                            searchOrgAccount
                        });
                    }
                }
            }
            this.handlePageChange(1);
        });
        this.getRiskTypes();
        // this.getAgentList();
        this.getMajorCaseTypes(tenant.code);
        this.getLevel();
        if ([7, 11, 12, 13, 15].includes(tenant.code)) {
            // 丹鸟，南京大排档，圆通，保时捷
            // 查询雇主公司数据
            this.getActiveEmployer();
        }
        if ([13].includes(tenant.code)) {
            // 圆通
            // 查询产品类型
            this.getProductTypeOfYuantong();
        }
        if ([15].includes(tenant.code)) {
            // 追星保时捷
            this.getConstant('reportTirePositions');
            this.getConstant('reportVehicleUsages');
            this.getConstant('reportTireDamageTypes');
        }
        if ([13, 17, 21, 24, 25, 26, 27].includes(tenant.code)) {
            // 圆通，人保达达
            // 查询保障方案数据
            this.getPlans(tenant.code);
        }
        if ([24, 25, 26, 27].includes(tenant.code)) {
            this.getProductType();
        }
    }

    getRiskTypes = () => {
        const { currentAgent } = this.props;
        // 当前租户无险种选择
        if ([17, 18, 19, 20].includes(currentAgent.tenant.code)) {
            return;
        }
        const tenantId = currentAgent && currentAgent.tenant ? currentAgent.tenant._id : '';
        getRiskTypes({
            tenantId
        })
            .then((res) => {
                this.setState({
                    riskTypes: res.result
                });
            })
            .catch((err) => { });
    };

    // 指派任务类型onChange
    onChangeCheckbox = (assignedTypes) => {
        this.setState({
            selectedAssignmentInfo: {
                ...this.state.selectedAssignmentInfo,
                selectedTypes: assignedTypes
            }
        });
    };

    onSearch = async () => {
        this.setState(
            {
                selectedRowKeys: [],
                selectedRows: []
            },
            () => this.handlePageChange(1)
        );
    };

    async handleClick(record) {
        const { actions } = this.props;
        getReportInfo(record.flowId, {
            from: 'agent'
        })
            .then(async (res) => {
                const report = res.result;
                if (report) {
                    if (report.ownCarLoss) {
                        actions.selectedCar(report.ownCarLoss._id);
                    } else {
                        actions.selectedCar(report._id);
                    }
                }
                await actions.reportPageOrForm('reportForm');
                await actions.selectedReport(report);
            })
            .catch((err) => { });
    }

    changeSearchTenant = (value) => {
        this.searchForm.current.setFieldsValue({
            searchOrgAccount: [],
            agentId: undefined,
            customerAgentId: undefined,
            clientReviewAgentId: undefined,
            defLossAgentId: undefined
        });
        // this.getAgentList();
        this.searchTenant = value;
        this.RemoteSearchSelectAgentId.fetchRemoteData(
            '',
            `&searchTenant=${value}&searchOrgAccount=${this.searchOrgAccount}&getRole=true`
        );
        this.RemoteSearchSelectCustomerAgentId.fetchRemoteData(
            '',
            `&searchTenant=${value}&searchOrgAccount=${this.searchOrgAccount}&getRole=true`
        );
        this.RemoteSearchSelectClientReviewAgentId.fetchRemoteData(
            '',
            `&searchTenant=${value}&searchOrgAccount=${this.searchOrgAccount}&getRole=true`
        );
        this.RemoteSearchSelectDefLossAgentId.fetchRemoteData(
            '',
            `&searchTenant=${value}&searchOrgAccount=${this.searchOrgAccount}&getRole=true`
        );
    };
    changeSearchOrgAccount = (value) => {
        const { filterVisible } = this.state;
        if (filterVisible) {
            this.filterForm.current.setFieldsValue({
                // state: [],
                // subState: [],
                agentId: undefined,
                customerAgentId: undefined,
                clientReviewAgentId: undefined,
                defLossAgentId: undefined
            });
        } else {
            this.searchForm.current.setFieldsValue({
                // state: [],
                // subState: [],
                agentId: undefined,
                customerAgentId: undefined,
                clientReviewAgentId: undefined,
                defLossAgentId: undefined
            });
        }
        this.searchOrgAccount = value;
        this.RemoteSearchSelectAgentId.fetchRemoteData(
            '',
            `&searchTenant=${this.searchTenant}&searchOrgAccount=${value}&getRole=true`
        );
        this.RemoteSearchSelectCustomerAgentId.fetchRemoteData(
            '',
            `&searchTenant=${this.searchTenant}&searchOrgAccount=${value}&getRole=true`
        );
        this.RemoteSearchSelectClientReviewAgentId.fetchRemoteData(
            '',
            `&searchTenant=${this.searchTenant}&searchOrgAccount=${value}&getRole=true`
        );
        this.RemoteSearchSelectDefLossAgentId.fetchRemoteData(
            '',
            `&searchTenant=${this.searchTenant}&searchOrgAccount=${value}&getRole=true`
        );
    };

    changeDaysType = (value) => {
        let createdDate = [];
        // 如果选择今天
        switch (value) {
            case 'today':
                createdDate = [moment(), moment()];
                break;
            case 'yesterday':
                createdDate = [moment().subtract(1, 'days'), moment().subtract(1, 'days')];
                break;
            case 'last7days':
                createdDate = [moment().subtract(6, 'days'), moment()];
                break;
            case 'last30days':
                createdDate = [moment().subtract(29, 'days'), moment()];
                break;
            case 'last6month':
                createdDate = [
                    moment()
                        .month(moment().month() - 5)
                        .startOf('month'),
                    moment()
                ];
                break;
            default:
                createdDate = [];
        }
        this.searchForm.current.setFieldsValue({
            createdDate
        });
    };
    changeCreatedTime = (values) => {
        this.filterForm.current.setFieldsValue({
            daysType: undefined
        });
    };
    downloadExcel = () => {
        const { currentAgent = {} } = this.props,
            opAgentId = (currentAgent && currentAgent._id) || '';
        this.setState({ isDownloadFile: true });
        exportReportData({
            opAgentId,
            ...this.getQueryParams()
        })
            .then((response) => {
                this.setState({ isDownloadFile: false });
                downloadFile(response.result);
            })
            .catch((err) => {
                message.error('导出失败');
                this.setState({ isDownloadFile: false });
            });
    };
    // 导出邮寄清单
    downloadExpressMaterial = () => {
        const { currentAgent = {} } = this.props,
            opAgentId = (currentAgent && currentAgent._id) || '';
        this.setState({ isDownloadExpressMaterial: true });
        exportExpressMaterial({
            opAgentId,
            ...this.getQueryParams()
        })
            .then((response) => {
                const { data } = response;
                if (
                    data.type ===
                    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
                ) {
                    const blob = new Blob([data], {
                        type: 'application/vnd.ms-excel'
                    });
                    downloadFile(URL.createObjectURL(blob), '邮寄清单.xlsx');
                } else if (data.type === 'application/json') {
                    //转换步骤
                    const file = new FileReader();
                    file.readAsText(data, 'utf-8');
                    file.onload = function () {
                        const result = JSON.parse(file.result);
                        message.error(result.errInfo)
                    }
                } else {
                    message.error('导出失败');
                }
                this.setState({ isDownloadExpressMaterial: false });
            })
            .catch((err) => {
                message.error('导出失败', err);
                this.setState({ isDownloadExpressMaterial: false });
            });
    };

    downloadReportDetailExcel = () => {
        const { currentAgent = {} } = this.props,
            opAgentId = (currentAgent && currentAgent._id) || '';
        this.setState({ isDownloadDetailFile: true });
        exportReportDetail({
            opAgentId,
            ...this.getQueryParams()
        })
            .then((response) => {
                this.setState({ isDownloadDetailFile: false });
                downloadFile(response.result);
            })
            .catch((err) => {
                message.error('导出失败');
                this.setState({ isDownloadDetailFile: false });
            });
    };
    /**
     * @param {*} orgs 所选工单的机构列表
     * 显示指派弹框
     * 1、agentRole.level === '1',坐席不可指派
     * 2、agentRole.level === '3',公司管理员可以指派不同机构的案件到不同机构下的坐席，如果勾选了不同机构的案件，指派类型全部勾选且禁用操作；如果只有一个机构的案件，则指派机构默认指向该机构
     * 3、agentRole.level === '2',机构管理员只能指派当前机构的案件到当前机构下的坐席，指派机构默认指向该机构
     */
    handleShowAssignModal = (orgs) => {
        const { currentAgent } = this.props, { accountAccess } = this.state;
        let tenantId = currentAgent?.tenant?._id || '';
        let orgAccountId = currentAgent?.orgAccount?._id || '';
        let assignedOrgAccountId = '', assignedTypes = []

        if (accountAccess === '3') {
            // 公司管理员 默认选中：
            // 点击指派后，统计勾选工单的orgAccount._id（机构_id）
            // 去重后，若发现只存在一个机构_id，那么'指派机构'默认选中'该机构_id'对应的项。
            // 否则 默认选中'请选择'。
            if (orgs.length > 1) {
                assignedOrgAccountId = undefined;
                assignedTypes = [1, 2];
            } else {
                assignedOrgAccountId = orgs[0];
                assignedTypes = [1];
            }
        } else if (accountAccess === '2') {
            // 机构管理员 默认选中：
            // '指派机构'默认选中'当前登录账号.orgAccount._id'对应的项。
            assignedOrgAccountId = orgAccountId;
            assignedTypes = [1];
        } else {
            // return;
            if (currentAgent?.permission.includes(DISPATCH_PERMISSION.REPORT_DISPATCH_COMPANY)) {
                if (orgs.length > 1) {
                    assignedOrgAccountId = undefined;
                    assignedTypes = [1, 2];
                } else {
                    assignedOrgAccountId = orgs[0];
                    assignedTypes = [1];
                }
            } else if ( currentAgent?.permission.includes(DISPATCH_PERMISSION.REPORT_DISPATCH_ORG) && !currentAgent?.permission.includes(DISPATCH_PERMISSION.REPORT_DISPATCH_COMPANY)) {
                assignedOrgAccountId = orgAccountId;
                assignedTypes = [1];
            } else {
                return;
            }
        }
        getAssignAgents({
            tenant: tenantId,
            orgAccount: assignedOrgAccountId || ''
        }).then((res) => {
            const { result } = res;
            this.setState({
                assignModalVisible: true,
                fullAssignableAgents: result.departments,
                assignableAgents: result.departments,
                outsideAgents: result.agents,
                fullOutsideAgents: result.agents,
                selectedAssignmentInfo: {
                    ...this.state.selectedAssignmentInfo,
                    selectedTypes: assignedTypes,
                    selectedOrgId: assignedOrgAccountId
                }
            });
        });
    };
    // 筛选搜索在客服组中的坐席
    onChangeAssignedName = (e) => {
        const agentName = e.target.value,
            { fullAssignableAgents, fullOutsideAgents } = this.state;
        if (this.timer) {
            clearTimeout(this.timer);
        }
        this.timer = setTimeout(() => {
            this.setState({
                assignableAgents: fullAssignableAgents.map((item) => ({
                    ...item,
                    agents: item.agents.filter(
                        (agent) =>
                            agent.fullName.toLowerCase().indexOf(agentName.toLowerCase()) >= 0
                    )
                })),
                outsideAgents: fullOutsideAgents.filter(
                    (agent) => agent.fullName.toLowerCase().indexOf(agentName.toLowerCase()) >= 0
                )
            });
        }, 500);
    };
    // 取消指派，重置数据
    handleCancelAssignModal = () => {
        this.setState({
            assignModalVisible: false,
            selectedAssignmentInfo: {
                selectedOrgId: undefined,
                selectedAgentId: '',
                selectedTypes: [1]
            }
        });
    };
    // 勾选指派
    handleAssignOk = async () => {
        const { pageIndex, selectedRowKeys, selectedAssignmentInfo } = this.state;
        const { selectedTypes, selectedAgentId } = selectedAssignmentInfo;
        this.setState({ assignReportLoading: true });
        if (!selectedAgentId) {
            this.setState({ assignReportLoading: false });
            message.warning('请选择要指派的坐席');
            return;
        }

        assignToAgent({
            flowIds: selectedRowKeys,
            targetAgentId: selectedAgentId,
            // agentId: currentAgent._id,
            types: selectedTypes
        })
            .then(({ result }) => {
                if (result && !result.error) {
                    this.setState({
                        selectedAssignmentInfo: {
                            selectedOrgId: undefined,
                            selectedAgentId: '',
                            selectedTypes: [1]
                        },
                        assignReportLoading: false,
                        assignModalVisible: false,
                        selectedRowKeys: [],
                        selectedRows: []
                    });
                    message.success('恭喜，指派成功！');
                    this.handlePageChange(pageIndex);
                } else {
                    this.setState({ assignReportLoading: false });
                    message.error('工单指派失败');
                }
            })
            .catch((err) => {
                this.setState({ assignReportLoading: false });
            });
    };
    // 指派全部
    handleAssignAllOk = async () => {
        const { pageIndex, selectedAssignmentInfo } = this.state;
        const { selectedTypes, selectedAgentId } = selectedAssignmentInfo;
        this.setState({ assignReportLoading: true });
        if (!selectedAgentId) {
            this.setState({ assignReportLoading: false });
            message.warning('请选择要指派的坐席');
            return;
        }
        const params = this.getQueryParams();

        assignToAgentAll({
            ...params,
            targetAgentId: selectedAgentId,
            types: selectedTypes
        })
            .then(({ result }) => {
                if (result && !result.error) {
                    this.setState({
                        selectedAssignmentInfo: {
                            selectedOrgId: undefined,
                            selectedAgentId: '',
                            selectedTypes: [1]
                        },
                        assignReportLoading: false,
                        assignModalVisible: false,
                        selectedRowKeys: [],
                        selectedRows: []
                    });
                    message.success('恭喜，指派成功！');
                    this.handlePageChange(pageIndex);
                } else {
                    this.setState({ assignReportLoading: false });
                    message.error('工单指派失败');
                }
            })
            .catch((err) => {
                this.setState({ assignReportLoading: false });
            });
    };
    // 按文件指派
    handleAssignByFile = async () => {
        const { pageIndex, selectedAssignmentInfo, assignInfo } = this.state;
        const { selectedTypes, selectedAgentId } = selectedAssignmentInfo;
        this.setState({ assignReportLoading: true });
        if (!selectedAgentId) {
            this.setState({ assignReportLoading: false });
            message.warning('请选择要指派的坐席');
            return;
        }
        try {
            const { result } = await assignToAgentByFile({
                file: assignInfo.fileId,
                targetAgentId: selectedAgentId,
                // agentId: currentAgent._id,
                types: selectedTypes
            })
            if (result && !result.error) {
                this.setState({
                    selectedAssignmentInfo: {
                        selectedOrgId: undefined,
                        selectedAgentId: '',
                        selectedTypes: [1]
                    },
                    assignReportLoading: false,
                    assignModalVisible: false,
                    selectedRowKeys: [],
                    selectedRows: []
                });
                message.success('恭喜，指派成功！');
                this.handlePageChange(pageIndex);
            } else {
                this.setState({ assignReportLoading: false });
                message.error('工单指派失败');
            }
        } catch {
            this.setState({ assignReportLoading: false });
        }
    };
    // 指派坐席
    handleAssignToAgent = (agentId) => {
        this.setState({
            selectedAssignmentInfo: { ...this.state.selectedAssignmentInfo, selectedAgentId: agentId }
        })
    };

    changeSurveyType = (value) => {
        this.setState({ surveyType: value });
    };

    getQueryParams = () => {
        const { accountAccess, query } = this.state;
        const filterValues = this.filterForm.current
            ? this.filterForm.current.getFieldsValue()
            : this.initialValues;
        
        const {
            state = [],
            subState = [],
            defLossState = [],
            accidentSecondType = [],
            majorCaseType = [],
            coopTaskTypes = [],
            complaintLevels = [],
            coreProductCodes = [],
            createdDate = [],
            riskLevelId = [],
            daysType,
            ...otherSearchValues
        } = this.searchForm.current.getFieldsValue();
        
        const {
            createdDate: filterCreatedTime,
            accidentDate = [],
            clientReviewDate = [],
            preCheckedDate = [],
            checkedDate = [],
            refoundDate = [],
            finishedDate = [],
            reviewNextDate = [],
            agentNextDate = [],
            lossNextDate = [],
            topFollowDate = [],
            receivedExpressDate = [],
            expressMaterialStatusDate = [],
            ...otherFilterValues
        } = filterValues;
        // 统一处理日期区间
        const timeQuery = [
            ['createdDate', createdDate],
            ['accidentDate', accidentDate],
            ['clientReviewDate', clientReviewDate],
            ['preCheckedDate', preCheckedDate],
            ['checkedDate', checkedDate],
            ['refoundDate', refoundDate],
            ['finishedDate', finishedDate],
            ['reviewNextDate', reviewNextDate],
            ['agentNextDate', agentNextDate],
            ['lossNextDate', lossNextDate],
            ['topFollowDate', topFollowDate],
            ['receivedExpressDate', receivedExpressDate],
            ['expressMaterialStatusDate', expressMaterialStatusDate]
        ].reduce((pre, cur) => {
            const formattedTime = splitTime.apply(null, cur);
            return { ...pre, ...formattedTime };
        }, {});
        const params = {
            ...otherFilterValues,
            ...otherSearchValues,
            ...timeQuery,
            ...query,
            accountAccess: accountAccess == '1' ? accountAccess : '',
            // 案件状态
            state: state.join(','),
            // 案件子状态
            subState: subState.join(','),
            // 定损任务状态
            defLossState: defLossState.join(','),
            // 事故类型 人车物
            accidentSecondType: accidentSecondType,
            // 案件类型， 常规-疑难-死亡...
            majorCaseType: majorCaseType.join(','),
            // 是否协作
            coopTaskTypes: coopTaskTypes.join(','),
            // 是否投诉
            complaintLevels: complaintLevels.join(','),
            // 险种
            coreProductCodes: coreProductCodes.join(','),
            // 分险等级
            riskLevelId: riskLevelId.join(','),
            // 排序字段
            orderBy: query.orderBy || '',
            // 排序方式
            order: query.order === 'ascend' ? 'asc' : 'dec'
        };
        const keys = Object.keys(params).filter(
            (key) => params[key] !== '' && params[key] !== undefined && params[key] !== null
        );
        const queryParams = keys.reduce((pre, cur) => ({ ...pre, [cur]: params[cur] }), {});
        const copyQueryParams = JSON.parse(JSON.stringify(queryParams));
        Object.keys(copyQueryParams).forEach((key) => {
            if (typeof copyQueryParams[key] === 'string') {
                // 去除首尾空格
                copyQueryParams[key] = copyQueryParams[key].replace(/^\s+|\s+$/g, '');
            }
        });
        return copyQueryParams;
    };

    // 分页、排序、筛选变化时触发
    handleTableChange = async (pagenations = {}, filters = {}, sorter = {}) => {
        const { query } = this.state;
        const { field = '', order = '' } = sorter,
            { current, pageSize } = pagenations;
        if ((field && query.orderBy !== field) || (order && query.order !== order)) {
            this.setState(
                {
                    pageIndex: 1,
                    pageSize,
                    query: {
                        ...query,
                        orderBy: field,
                        order: order
                    }
                },
                this.onSearch
            );
        } else {
            this.setState({ pageSize }, () => {
                this.handlePageChange(current);
            });
        }
    };

    handlePageChange = async (pageIndex = 1) => {
        const { pageSize } = this.state,
            params = this.getQueryParams();
        this.setState({ loading: true });
        getReportList({
            ...params,
            pageIndex,
            pageSize
        })
            .then(({ result }) => {
                this.setState({
                    pageIndex,
                    loading: false,
                    reportReceipts: result
                });
            })
            .catch(() => {
                this.setState({
                    loading: false
                });
            });
    };
    // 更改机构时，重新获取机构下的客服组坐席
    handleChangeOrgAccount = async (value) => {
        const { currentAgent = {} } = this.props,
            { tenant } = currentAgent;
        const { selectedRows, assignType, assignInfo, selectedAssignmentInfo } = this.state;
        let diffAccount = [];
        if (assignType === 'assign') {
            diffAccount = Array.from(new Set(selectedRows.map((item) => item.orgAccountId)));
        }
        if (['assignAll', 'assignByFile'].includes(assignType)) {
            diffAccount = assignInfo.orgAccounts;
        }
        this.setState({
            selectedAssignmentInfo: {
                selectedAgentId: '',
                selectedOrgId: value,
                // 所选工单所属多机构，或跨机构指派，则必须勾选“常规工单和定损任务
                selectedTypes: diffAccount.length > 1 || (diffAccount[0] !== value && value) ? [1, 2] : selectedAssignmentInfo.selectedTypes
            }
        });
        getAssignAgents({
            tenant: tenant._id,
            orgAccount: value || ''
        }).then((res) => {
            const { result } = res;
            this.setState({
                assignModalVisible: true,
                fullAssignableAgents: result.departments,
                assignableAgents: result.departments,
                outsideAgents: result.agents,
                fullOutsideAgents: result.agents,
            });
        });
    };
    // 获取全部可选机构
    getOrganization = () => {
        return new Promise((resolve) => {
            const { currentAgent = {} } = this.props,
                { tenant = {} } = currentAgent;
            getOrganizations({
                pageIndex: 1,
                pageSize: 1000,
                searchTenant: (tenant && tenant._id) || ''
            })
                .then(({ result }) => {
                    this.setState({
                        organization: result.list
                    });
                    resolve(result.list)
                })
                .catch((err) => {
                    message.error(err.message);
                });
        })
    };
    // 重置搜索组件
    resetSearchParams = () => {
        const { currentAgent = {} } = this.props
        const tenantCode = currentAgent.tenant && currentAgent.tenant.code;
        this.initialValues = { ...this.defaultValues };
        this.searchForm.current.resetFields();
        this.searchForm.current.setFieldsValue(this.initialValues);
        if (this.filterForm.current) {
            this.filterForm.current.resetFields();
            this.filterForm.current.setFieldsValue(this.initialValues);
        }
        this.setState(
            {
                isFilter: false,
                query: {
                    order: '',
                    kwType: [21].includes(tenantCode) ? 'reportId' : 'flowId',
                    orderBy: '',
                    keyWord: ''
                }
            },
            () => this.handlePageChange(1)
        );
    };

    getLevel = () => {
        getRiskLevels({
            agentId: this.props.currentAgent._id
        }).then((res) => {
            this.setState({
                levels: res.result
            });
        });
    };
    getActiveEmployer = () => {
        getActiveEmployer({
            agentId: this.props.currentAgent._id
        }).then((res) => {
            this.setState({
                activeEmployer: res.result.list
            });
        });
    };

    //查询保障方案，固定查询上海人民保险股份有限公司的保障方案
    getPlans = (code) => {
        const { currentAgent } = this.props;
        const agentId = currentAgent && currentAgent._id;
        if (!agentId) {
            return;
        }
        getPlansByTenant({
            agentId,
            underPolicyCompanyId: [13].includes(code) ? 'PICCSH' : undefined
        })
            .then((res) => {
                this.setState({
                    plans: res.result
                });
            })
            .catch((err) => {
                message.error(err.message);
            });
    };
    // 展开更多筛选项，将搜索框的内容同步到更多筛选项中
    showMoreFilter = () => {
        const values = this.searchForm.current.getFieldsValue();
        this.setState(
            {
                filterVisible: true
            },
            () => {
                this.filterForm.current.setFieldsValue({ ...this.initialValues, ...values });
                this.initialValues = { ...this.defaultValues };
            }
        );
    };
    // 查询更多筛选项，关闭更多筛选项，将搜索框的内容同步到搜索框中
    searchMoreFilter = () => {
        const values = this.filterForm.current.getFieldsValue();
        const searchValues = this.searchForm.current.getFieldsValue();
        this.setState(
            {
                isFilter: true,
                filterVisible: false
            },
            () => {
                this.searchForm.current.setFieldsValue({ ...searchValues, ...values });
                this.onSearch();
            }
        );
    };
    closeMoreFilter = () => {
        this.setState({
            filterVisible: false
        });
    };
    // 工单状态change事件，不包含已结案时，清空工单子状态
    changeState = (values) => {
        if (!values.includes('finished')) {
            this.searchForm.current.setFieldsValue({
                subState: undefined
            });
        }
    };
    changeDefLossState = (values) => {
        if (!values.includes('checking')) {
            this.searchForm.current.setFieldsValue({
                defLossSubState: undefined
            });
        }
    };
    goDetail = (flowId) => {
        const { query } = this.state;
        const filterValues = this.filterForm.current
            ? this.filterForm.current.getFieldsValue()
            : {};
        const searchValues = this.searchForm.current.getFieldsValue();
        this.props.history.push({
            pathname: `/customerCenter/ReportDetail/${flowId}`,
            query: {
                ...this.initialValues,
                isFilter: this.state.isFilter,
                pageIndex: this.state.pageIndex,
                pageSize: this.state.pageSize,
                // ...query,
                ...searchValues,
                ...filterValues
            }
        });
    };
    // 指派全部
    handleAssign = ({ key }) => {
        switch (key) {
            case 'assign-all':
                Modal.confirm({
                    title: '确定把查询结果的所有案件进行统一指派?',
                    onOk: () => this.handleAssignAll()
                });
                break;
            case 'import-assign':
                this.setState({
                    importAssignmentVisible: true
                })
                break;
            default:
        }
    };
    // 指派已勾选案件
    handleAssignSelected = () => {
        const { selectedRows } = this.state;
        if (selectedRows.length === 0) {
            message.info('请先选择案件');
            return;
        }
        this.setState({
            assignType: 'assign'
        });
        this.handleShowAssignModal(Array.from(new Set(selectedRows.map((item) => item.orgAccountId))));
    }
    // 指派全部
    handleAssignAll = async () => {
        const params = this.getQueryParams();
        try {
            const { result } = await queryAssignToAgentAll(params);
            this.setState({
                assignInfo: result,
                assignType: 'assignAll'
            });
            this.handleShowAssignModal(result.orgAccounts);
        } catch { }
    };
    // 导入指派文件上传回调
    handleAssignFileCallback = (assignInfo) => {
        this.setState({
            importAssignmentVisible: false,
            assignInfo,
            assignType: 'assignByFile'
        });
        this.handleShowAssignModal(assignInfo.orgAccounts);
    }
    // 获取已勾选要指派的工单的机构列表
    getDiffOrg = () => {
        const { assignInfo, assignType, selectedRows } = this.state;
        if (assignType === 'assign') {
            return Array.from(new Set(selectedRows.map((item) => item.orgAccountId)));
        }
        if (['assignAll', 'assignByFile'].includes(assignType)) {
            return assignInfo.orgAccounts;
        }
        return []
    }

    render() {
        const { currentAgent = {} } = this.props,
            {
                reportReceipts = {},
                agents,
                filterVisible,
                accountAccess,
                query,
                pageIndex,
                pageSize,
                assignableAgents = [],
                outsideAgents = [],
                assignedAgent = [],
                selectedRows = [],
                importExpressVisible,
                importAssignmentVisible,
                assignInfo,
                selectedAssignmentInfo
            } = this.state,
            { tenant = {}, orgAccount = {} } = currentAgent;
        
        const minDate = currentAgent.loginName === 'piccadmin' ? '2025-11-19' : null;
        
        let reportsList = [],
            count;
        let rowSelection,
            columns = [];
        let diffAccount = this.getDiffOrg();
        const permission = currentAgent?.permission || []

        const values =
            this.searchForm && this.searchForm.current && this.searchForm.current.getFieldsValue();

        let kwTypeOpts = getSearchParams(tenant.code).map((item) => (
            <Option key={item.value} value={item.value}>
                {item.label}
            </Option>
        ));

        if (reportReceipts) {
            reportsList = reportReceipts.list;
            columns = reportReceipts.columns;
            count = reportReceipts.count;
            // console.log('reportsList', reportsList)
        }
        if (columns.length > 0) {
            columns[0]['fixed'] = 'left';
            columns[0]['render'] = (text, { tags = [], flowId = '' }) => {
                return (
                    <React.Fragment>
                        <a onClick={() => this.goDetail(flowId)}>{text}</a>
                        <p style={{ transform: 'scale(0.8)' }}>
                            {tags.map(({ name = '', color = '' }, index) => (
                                <Tag color={color} key={index}>
                                    {' '}
                                    {name}{' '}
                                </Tag>
                            ))}
                        </p>
                    </React.Fragment>
                );
            };
        }
        const getRecordCheckedDisabled = (record = {}) => {
            const agentOrgId = (currentAgent.orgAccount && currentAgent.orgAccount._id) || -1;
            // console.log('agentOrgId', agentOrgId, 'orgId', record.orgAccountId)
            // return accountAccess === '3' ||
            //     (accountAccess === '2' && agentOrgId === record.orgAccountId)
            //     ? false
            //     : true;
            console.log(currentAgent);
            if (currentAgent.permission.includes(DISPATCH_PERMISSION.REPORT_DISPATCH_COMPANY)) {
                return false
            } else if (currentAgent.permission.includes(DISPATCH_PERMISSION.REPORT_DISPATCH_ORG) && agentOrgId === record.orgAccountId) {
                return false
            } else {
                return true
            }
        };

        rowSelection = {
            selectedRowKeys: this.state.selectedRowKeys,
            onChange: (selectedRowKeys, selectedRows) => {
                this.setState({
                    selectedRowKeys,
                    selectedRows
                });
            },
            getCheckboxProps: (record) => ({
                disabled: getRecordCheckedDisabled(record)
            })
        };

        const agentOpts = agents
            .filter((agent) => agent.agentRole && agent.agentRole.isSurvey)
            .map((agent) => (
                <Option value={agent._id} key={agent._id}>
                    {agent.fullName}
                </Option>
            ));

        const agentOptArr = [
            <Option value="" key="">
                全部坐席
            </Option>,
            ...agentOpts
        ];

        let { stateObj } = reportReceipts || {};
        let pageState = (
            <div className="Statistics_div">
                <span key={`count_pageState${count}`}>
                    <strong>共</strong>
                    {count || 0}
                    <strong>条</strong>
                </span>
            </div>
        );
        if (stateObj) {
            let pageStateList = [],
                indexState = 0;
            _.forEach(stateObj, (value, key) => {
                if (indexState == 0) {
                    pageStateList.push(
                        <span key={`count_${key}${count}`}>{`${t('reportStates::' + key)}${value || 0
                            }条`}</span>
                    );
                } else {
                    pageStateList.push(
                        <span key={`count_${key}${count}`}>{`，${t('reportStates::' + key)}${value || 0
                            }条`}</span>
                    );
                }
                indexState++;
            });
            pageState = (
                <div className="Statistics_div">
                    <span key={`count_pageState${count}`}>
                        <strong>共</strong>
                        {count || 0}
                        <strong>条</strong>
                    </span>
                    {pageStateList}
                </div>
            );
        }

        const assignDisabled = !(selectedAssignmentInfo.selectedOrgId && selectedAssignmentInfo.selectedAgentId && selectedAssignmentInfo.selectedTypes.length);
        const tenantCode = currentAgent.tenant.code;

        return (
            <div className="report-page-name-space">
                <div
                    className="navigation"
                    style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between'
                    }}
                >
                    <ol>
                        <li>
                            <a role="button">
                                <span>业务中心</span>
                            </a>
                        </li>
                        <li>
                            <a>
                                <span>工单列表</span>
                            </a>
                        </li>
                    </ol>
                    {/* <i
                        className={`iconfont ${this.state.isFilter ? 'icon-filter-full' : 'icon-filter'
                            }`}
                        onClick={this.showMoreFilter}
                    ></i> */}
                </div>
                <div className="searchDiv_reportPage">
                    <Form name="search-form" ref={this.searchForm}>
                        <Row gutter={[12, 12]} type="flex">
                            <Col span={4}>
                                <Form.Item name="daysType">
                                    <Select
                                        placeholder="请选择"
                                        size="small"
                                        allowClear={true}
                                        onChange={this.changeDaysType}
                                    >
                                        <Option value="today">今天</Option>
                                        <Option value="yesterday">昨天</Option>
                                        <Option value="last7days">过去七天</Option>
                                        <Option value="last30days">过去30天</Option>
                                        <Option value="last6month">过去6个月</Option>
                                    </Select>
                                </Form.Item>
                            </Col>
                            {/* 当日期类型不选时，可自定义选择日期；其他情况不能自定义选择日期 */}
                            <Col span={4}>
                                <Form.Item
                                    shouldUpdate={(prevValues, currentValues) =>
                                        prevValues.daysType !== currentValues.daysType
                                    }
                                    noStyle
                                >
                                    {({ getFieldValue }) => {
                                        const daysType = getFieldValue('daysType');
                                        return (
                                            <Form.Item name="createdDate">
                                                <RangePicker
                                                    disabled={daysType}
                                                    size="small"
                                                    format="YYYY-MM-DD"
                                                    allowClear={true}
                                                    disabledDate={(current) => disabledDate(current, minDate)}
                                                    style={{ width: '100%' }}
                                                />
                                            </Form.Item>
                                        );
                                    }}
                                </Form.Item>
                            </Col>

                            <Col span={4}>
                                <Form.Item name="searchTenant">
                                    <Select
                                        size="small"
                                        allowClear
                                        placeholder="公司"
                                        disabled={accountAccess !== 'admin' ? true : false}
                                        onChange={this.changeSearchTenant}
                                    >
                                        {currentAgent && currentAgent.tenant ? (
                                            <Option
                                                value={currentAgent.tenant._id}
                                                key={currentAgent.tenant._id}
                                            >
                                                {currentAgent.tenant.name}
                                            </Option>
                                        ) : null}
                                    </Select>
                                </Form.Item>
                            </Col>
                            {/* 若当前账号所在机构无跨机构查询权限，则禁用 */}
                            <Col span={4}>
                                <Form.Item name="searchOrgAccount">
                                    <Select
                                        size="small"
                                        placeholder="机构"
                                        allowClear
                                        onChange={this.changeSearchOrgAccount}
                                        disabled={!overOrgQueryReportsPermission(currentAgent)}
                                        mode="multiple"
                                    >
                                        {this.state.organization.map((item) => (
                                            <Option value={item._id} key={item._id}>
                                                {item.orgName}
                                            </Option>
                                        ))}
                                    </Select>
                                </Form.Item>
                            </Col>
                            <Col span={4}>
                                <Form.Item name="referer">
                                    <Select allowClear placeholder="报案来源" size="small">
                                        {![21, 24, 25, 26, 27].includes(tenantCode) ? (
                                            <Option key="MINA" value="MINA">
                                                小程序
                                            </Option>
                                        ) : null}
                                        {[21].includes(tenantCode) ? (
                                            <Option key="CUSTOMER " value="CUSTOMER ">
                                                饿了么
                                            </Option>
                                        ) : null}
                                        {tenantCode === 8 ? (
                                            <Option key="ELEME" value="ELEME">
                                                饿了么
                                            </Option>
                                        ) : null}
                                        {![15, 24, 25, 26, 27].includes(tenantCode) ? (
                                            <Option key="AGENT" value="AGENT">
                                                坐席自建
                                            </Option>
                                        ) : null}
                                        {tenantCode === 13 ? (
                                            <Option key="YUANTONG" value="YUANTONG">
                                                圆通秒核
                                            </Option>
                                        ) : null}
                                        {[14, 19].includes(tenantCode) ? (
                                            <Option key="HALUO-H5" value="HALUO-H5">
                                                h5
                                            </Option>
                                        ) : null}
                                        {[20].includes(tenantCode) ? (
                                            <Option key="H5" value="H5">
                                                h5页面
                                            </Option>
                                        ) : null}
                                        {
                                            [17, 24].includes(tenantCode) ? (
                                                <Option key="DADA">达达平台</Option>
                                            ) : null
                                        }
                                        {
                                            [25, 26, 27].includes(tenantCode) ? (
                                                <Option key="QIANHAI2">前海</Option>
                                            ) : null
                                        }
                                    </Select>
                                </Form.Item>
                            </Col>
                            {![14, 19].includes(tenantCode) ? (
                                <Col span={4}>
                                    <Form.Item name="surveyType">
                                        <Select
                                            size="small"
                                            placeholder="是否视频定损"
                                            allowClear
                                            onChange={this.changeSurveyType}
                                        >
                                            <Option value="1">视频定损</Option>
                                            <Option value="0">非视频定损</Option>
                                        </Select>
                                    </Form.Item>
                                </Col>
                            ) : null}
                            <Col span={4}>
                                <Form.Item name="state">
                                    <Select
                                        placeholder="全部状态"
                                        mode="multiple"
                                        size="small"
                                        onChange={this.changeState}
                                    >
                                        {reportStateList.map((item) => (
                                            <Option key={item.value} value={item.value}>
                                                {item.label}
                                            </Option>
                                        ))}
                                    </Select>
                                </Form.Item>
                            </Col>
                            <Form.Item
                                shouldUpdate={(prevValues, currentValues) =>
                                    prevValues.state !== currentValues.state
                                }
                                noStyle
                            >
                                {({ getFieldValue }) => {
                                    const state = getFieldValue('state');
                                    return state && state.includes('finished') ? (
                                        <Col span={4}>
                                            <Form.Item name="subState">
                                                <Select
                                                    placeholder="全部状态"
                                                    mode="multiple"
                                                    size="small"
                                                >
                                                    {finishedStateList.map((item) => (
                                                        <Option key={item.value} value={item.value}>
                                                            {item.label}
                                                        </Option>
                                                    ))}
                                                </Select>
                                            </Form.Item>
                                        </Col>
                                    ) : null;
                                }}
                            </Form.Item>
                            {![15, 19].includes(tenantCode) ? (
                                <React.Fragment>
                                    <Col span={4}>
                                        <Form.Item name="defLossState">
                                            <Select
                                                placeholder="全部定损状态"
                                                mode="multiple"
                                                size="small"
                                                onChange={this.changeDefLossState}
                                            >
                                                {lossStateList.map((item) => (
                                                    <Option value={item.value} key={item.value}>
                                                        {item.label}
                                                    </Option>
                                                ))}
                                            </Select>
                                        </Form.Item>
                                    </Col>
                                    <Form.Item
                                        shouldUpdate={(prevValues, currentValues) =>
                                            prevValues.defLossState !== currentValues.defLossState
                                        }
                                        noStyle
                                    >
                                        {({ getFieldValue }) => {
                                            const defLossState = getFieldValue('defLossState');
                                            return defLossState &&
                                                defLossState.includes('checking') ? (
                                                <Col span={4}>
                                                    <Form.Item name="defLossSubState">
                                                        <Select
                                                            placeholder="全部定损子状态"
                                                            size="small"
                                                        >
                                                            {lossSubStateList.map((item) => (
                                                                <Option
                                                                    value={item.value}
                                                                    key={item.value}
                                                                >
                                                                    {item.label}
                                                                </Option>
                                                            ))}
                                                        </Select>
                                                    </Form.Item>
                                                </Col>
                                            ) : null;
                                        }}
                                    </Form.Item>

                                    {/*  */}
                                    <Col span={4}>
                                        <Form.Item name="accidentFirstType">
                                            <Select placeholder="单方/多方" size="small">
                                                {accidentFirstTypeList.map((item) => (
                                                    <Option value={item.value} key={item.value}>
                                                        {item.label}
                                                    </Option>
                                                ))}
                                            </Select>
                                        </Form.Item>
                                    </Col>
                                    {/* 查询损失类型 */}
                                    <Col span={4}>
                                        <Form.Item name="accidentSecondType">
                                            <Select
                                                placeholder="全部损失类型"
                                                size="small"
                                                allowClear
                                            >
                                                {accidentSecondTypeList.map((item) => (
                                                    <Option value={item.value} key={item.value}>
                                                        {item.label}
                                                    </Option>
                                                ))}
                                            </Select>
                                        </Form.Item>
                                    </Col>
                                </React.Fragment>
                            ) : null}

                            <Col span={4}>
                                <Form.Item name="agentId">
                                    {/* <Select
                                        size="small"
                                        showSearch
                                        optionFilterProp="children"
                                        notFoundContent="无法找到"
                                        placeholder="处理人"
                                    >
                                        {agentOptArr}
                                    </Select> */}

                                    <RemoteSearchSelect
                                        allowClear
                                        size="small"
                                        placeholder="处理人"
                                        style={{ width: 120 }}
                                        url="/api/agents/simple"
                                        paramName="searchStr"
                                        fieldName="agents"
                                        textName="fullName"
                                        valueName="_id"
                                        query={`&searchOrgAccount=${(values && values.searchOrgAccount) || ''
                                            }&searchTenant=${(values && values.searchTenant) || ''
                                            }&getRole=true`}
                                        pageSize={1000}
                                        ref={(RemoteSearchSelectAgentId) =>
                                        (this.RemoteSearchSelectAgentId =
                                            RemoteSearchSelectAgentId)
                                        }
                                        filter={
                                            '(agent) => agent.agentRole && agent.agentRole.isSurvey'
                                        }
                                    />
                                </Form.Item>
                            </Col>
                            <Col span={4}>
                                <Form.Item name="customerAgentId">
                                    {/* <Select
                                        size="small"
                                        showSearch
                                        optionFilterProp="children"
                                        notFoundContent="无法找到"
                                        placeholder="客服坐席"
                                    >
                                        <Option value="" key="">资料坐席</Option>
                                        {
                                            agentOpts
                                        }
                                    </Select> */}
                                    <RemoteSearchSelect
                                        allowClear
                                        size="small"
                                        placeholder="资料坐席"
                                        style={{ width: 120 }}
                                        url="/api/agents/simple"
                                        paramName="searchStr"
                                        fieldName="agents"
                                        textName="fullName"
                                        valueName="_id"
                                        query={`&searchOrgAccount=${(values && values.searchOrgAccount) || ''
                                            }&searchTenant=${(values && values.searchTenant) || ''
                                            }&getRole=true`}
                                        pageSize={1000}
                                        ref={(RemoteSearchSelectCustomerAgentId) =>
                                        (this.RemoteSearchSelectCustomerAgentId =
                                            RemoteSearchSelectCustomerAgentId)
                                        }
                                        filter={
                                            '(agent) => agent.agentRole && agent.agentRole.isSurvey'
                                        }
                                    />
                                </Form.Item>
                            </Col>
                            <Col span={4}>
                                <Form.Item name="clientReviewAgentId">
                                    {/* <Select
                                        size="small"
                                        showSearch
                                        optionFilterProp="children"
                                        notFoundContent="无法找到"
                                        placeholder="回访坐席"
                                    >
                                        <Option value="" key="">回访坐席</Option>
                                        {
                                            agentOpts
                                        }
                                    </Select> */}
                                    <RemoteSearchSelect
                                        allowClear
                                        size="small"
                                        placeholder="回访坐席"
                                        style={{ width: 120 }}
                                        url="/api/agents/simple"
                                        paramName="searchStr"
                                        fieldName="agents"
                                        textName="fullName"
                                        valueName="_id"
                                        query={`&searchOrgAccount=${(values && values.searchOrgAccount) || ''
                                            }&searchTenant=${(values && values.searchTenant) || ''
                                            }&getRole=true`}
                                        pageSize={1000}
                                        ref={(RemoteSearchSelectClientReviewAgentId) =>
                                        (this.RemoteSearchSelectClientReviewAgentId =
                                            RemoteSearchSelectClientReviewAgentId)
                                        }
                                        filter={
                                            '(agent) => agent.agentRole && agent.agentRole.isSurvey'
                                        }
                                    />
                                </Form.Item>
                            </Col>
                            {![15, 19].includes(tenantCode) ? (
                                <Col span={4}>
                                    <Form.Item name="defLossAgentId">
                                        {/* <Select
                                            size="small"
                                            showSearch
                                            optionFilterProp="children"
                                            notFoundContent="无法找到"
                                            placeholder="定损坐席"
                                        >
                                            <Option value="" key="">全部定损坐席</Option>
                                            {
                                                agentOpts
                                            }
                                        </Select> */}
                                        <RemoteSearchSelect
                                            allowClear
                                            size="small"
                                            placeholder="全部定损坐席"
                                            style={{ width: 120 }}
                                            url="/api/agents/simple"
                                            paramName="searchStr"
                                            fieldName="agents"
                                            textName="fullName"
                                            valueName="_id"
                                            query={`&searchOrgAccount=${(values && values.searchOrgAccount) || ''
                                                }&searchTenant=${(values && values.searchTenant) || ''
                                                }&getRole=true`}
                                            pageSize={1000}
                                            ref={(RemoteSearchSelectDefLossAgentId) =>
                                            (this.RemoteSearchSelectDefLossAgentId =
                                                RemoteSearchSelectDefLossAgentId)
                                            }
                                            filter={
                                                '(agent) => agent.agentRole && agent.agentRole.isSurvey'
                                            }
                                        />
                                    </Form.Item>
                                </Col>
                            ) : null}
                            <Col span={4}>
                                <Form.Item name="isLostContactCsr">
                                    <Select placeholder="是否失联" size="small" allowClear>
                                        <Option key={0} value={0}>
                                            未失联
                                        </Option>
                                        <Option key={1} value={1}>
                                            失联
                                        </Option>
                                    </Select>
                                </Form.Item>
                            </Col>
                            <Col span={4}>
                                <Form.Item name="majorCaseType">
                                    <Select placeholder="案件类型" size="small" mode="multiple">
                                        <Option key='NORMAL' value='NORMAL'>
                                            常规案
                                        </Option>
                                        {this.state.majorCaseTypes.map((item) => (
                                            <Option key={item.value} value={item.value}>
                                                {item.label}
                                            </Option>
                                        ))}
                                    </Select>
                                </Form.Item>
                            </Col>
                            <Col span={4}>
                                <Form.Item name="coopTaskTypes">
                                    <Select
                                        placeholder="是否协作"
                                        size="small"
                                        allowClear
                                        mode="multiple"
                                    >
                                        {coopTaskTypeList.map((item) => (
                                            <Option value={item.value} key={item.value}>
                                                {item.label}
                                            </Option>
                                        ))}
                                    </Select>
                                </Form.Item>
                            </Col>
                            <Col span={4}>
                                <Form.Item name="complaintLevels">
                                    <Select
                                        placeholder="是否投诉"
                                        size="small"
                                        allowClear
                                        mode="multiple"
                                    >
                                        {complaintLevelList.map((item) => (
                                            <Option value={item.value} key={item.value}>
                                                {item.label}
                                            </Option>
                                        ))}
                                    </Select>
                                </Form.Item>
                            </Col>
                            {[8].includes(tenantCode) ? (
                                <Col span={4}>
                                    <Form.Item name="elemeAuditStatus">
                                        <Select placeholder="饿了么状态" size="small" allowClear>
                                            {elemeAuditStatusList.map((item) => (
                                                <Option key={item.value} value={item.value}>
                                                    {item.label}
                                                </Option>
                                            ))}
                                        </Select>
                                    </Form.Item>
                                </Col>
                            ) : null}
                            {[21].includes(tenantCode) ? (
                                <Col span={4}>
                                    <Form.Item name="elemeAuditStatus">
                                        <Select placeholder="饿了么状态" size="small" allowClear>
                                            {QIANHAIelemeAuditStatusList.map((item) => (
                                                <Option key={item.value} value={item.value}>
                                                    {item.label}
                                                </Option>
                                            ))}
                                        </Select>
                                    </Form.Item>
                                </Col>
                            ) : null}
                            {![18, 19, 20].includes(tenantCode) ? (
                                <Col span={4}>
                                    <Form.Item name="clientReview">
                                        <Select allowClear size="small" placeholder="是否回访">
                                            <Option value="0">未回访</Option>
                                            <Option value="2">回访完成</Option>
                                            <Option value="1">回访未接</Option>
                                        </Select>
                                    </Form.Item>
                                </Col>
                            ) : null}
                            <Col span={4}>
                                <Form.Item name="riskLevelId">
                                    <Select
                                        allowClear
                                        placeholder="风险等级"
                                        size="small"
                                        mode="multiple"
                                    >
                                        {this.state.levels.map((item) => (
                                            <Option key={item.levelId} value={item.levelId}>
                                                {item.levelName}
                                            </Option>
                                        ))}
                                    </Select>
                                </Form.Item>
                            </Col>
                            {/*  */}
                            {![15, 19].includes(tenantCode) ? (
                                <Col span={4}>
                                    <Form.Item name="casualty">
                                        <Select allowClear placeholder="人伤情况" size="small">
                                            {casualtyList.map((item) => (
                                                <Option key={item.value} value={item.value}>
                                                    {item.label}
                                                </Option>
                                            ))}
                                        </Select>
                                    </Form.Item>
                                </Col>
                            ) : null}
                            {/* 人保达达新增参数 */}
                            {/* 核赔情况 */}
                            {[17].includes(tenantCode) ? (
                                <Col span={4}>
                                    <Form.Item name="insureCompStatus">
                                        <Select allowClear placeholder="保司状态" size="small">
                                            {this.state.PICCCaseStatusList.map((item) => (
                                                <Option key={item.value} value={item.value}>
                                                    {item.label}
                                                </Option>
                                            ))}
                                        </Select>
                                    </Form.Item>
                                </Col>
                            ) : null}

                            {[18].includes(tenantCode) ? (
                                <Col span={4}>
                                    <Form.Item name="insureCompStatus">
                                        <Select allowClear placeholder="保司状态" size="small">
                                            {this.state.DAJIACaseStatusList.map((item) => (
                                                <Option key={item.value} value={item.value}>
                                                    {item.label}
                                                </Option>
                                            ))}
                                        </Select>
                                    </Form.Item>
                                </Col>
                            ) : null}
                            {/* code 17  人保达达 */}
                            {![17, 18, 19, 20].includes(tenantCode) ? (
                                <Col span={4}>
                                    <Form.Item name="coreProductCodes">
                                        <Select
                                            allowClear
                                            placeholder="险种"
                                            size="small"
                                            mode="multiple"
                                        >
                                            {this.state.riskTypes.map((riskType) => (
                                                <Option
                                                    key={riskType.coreProductCode}
                                                    value={riskType.coreProductCode}
                                                >
                                                    {riskType.coreProductName}
                                                </Option>
                                            ))}
                                        </Select>
                                    </Form.Item>
                                </Col>
                            ) : null}
                            {![17, 21, 24, 25, 26, 27].includes(tenantCode) && ![13].includes(tenantCode) ? (
                                <Col span={4}>
                                    <Form.Item name="claimState">
                                        <Select allowClear placeholder="核赔状态" size="small">
                                            <Option value="pending">待领取</Option>
                                            <Option value="checking">审核中</Option>
                                            <Option value="rejected">驳回</Option>
                                            <Option value="approved">已通过</Option>
                                        </Select>
                                    </Form.Item>
                                </Col>
                            ) : null}
                            {/* 保障方案 */}
                            {[17, 21, 24, 25, 26, 27].includes(tenantCode) ? (
                                <React.Fragment>
                                    <Col span={4}>
                                        <Form.Item name="planCode">
                                            <Select allowClear placeholder="保障方案" size="small">
                                                {this.state.plans.map((item) => (
                                                    <Option value={item.planCode} key={item.planCode}>
                                                        {item.planName}
                                                    </Option>
                                                ))}
                                            </Select>
                                        </Form.Item>
                                    </Col>
                                    <Col span={4}>
                                        <Form.Item name="claimState">
                                            <Select allowClear placeholder="核赔状态" size="small">
                                                <Option value="pending">待领取</Option>
                                                <Option value="checking">审核中</Option>
                                                <Option value="rejected">驳回</Option>
                                                <Option value="approved">已通过</Option>
                                            </Select>
                                        </Form.Item>
                                    </Col>
                                </React.Fragment>
                            ) : null}

                            {[24, 25, 26, 27].includes(tenantCode) ? (
                                <Col span={4}>
                                    <Form.Item name="productCode">
                                        <Select allowClear placeholder="产品类型" size="small">
                                            {this.state.riskProducts.map((item) => (
                                                <Option value={item.productCode} key={item.productCode}>
                                                    {item.productName}
                                                </Option>
                                            ))}
                                        </Select>
                                    </Form.Item>
                                </Col>
                            ) : null}
                            {/* 新增参数 险种 */}

                            {/*饿了么 新增参数 是否线下 */}
                            {[8].includes(tenantCode) ? (
                                <React.Fragment>
                                    <Col span={4}>
                                        <Form.Item name="surveyMethod">
                                            <Select
                                                allowClear
                                                placeholder="是否线下查勘"
                                                size="small"
                                            >
                                                <Option key="OFFLINE_SURVEY" value="OFFLINE_SURVEY">
                                                    线下查勘
                                                </Option>
                                                <Option key="ONLINE_SURVEY" value="ONLINE_SURVEY">
                                                    线上查勘
                                                </Option>
                                            </Select>
                                        </Form.Item>
                                    </Col>
                                    <Col span={4}>
                                        <Form.Item name="insuranceResp">
                                            <Select allowClear placeholder="保险责任" size="small">
                                                <Option key="0" value="0">
                                                    责任内
                                                </Option>
                                                <Option key="1" value="1">
                                                    责任外
                                                </Option>
                                            </Select>
                                        </Form.Item>
                                    </Col>
                                </React.Fragment>
                            ) : null}

                            {/* 新增参数 全部雇主 */}
                            {[7, 11, 12, 13].includes(tenantCode) ? (
                                <Col span={4}>
                                    <Form.Item name="employerCompanyId">
                                        <Select allowClear placeholder="全部雇主" size="small">
                                            {this.state.activeEmployer.map((item) => (
                                                <Option
                                                    key={item.employerCompanyId}
                                                    value={item.employerCompanyId}
                                                >
                                                    {item.companyName}
                                                </Option>
                                            ))}
                                        </Select>
                                    </Form.Item>
                                </Col>
                            ) : null}
                            {/* 圆通  新增参数 */}
                            {[13].includes(tenantCode) ? (
                                <React.Fragment>
                                    <Col span={4}>
                                        <Form.Item name="productCode">
                                            <Select allowClear placeholder="产品类型" size="small">
                                                {this.state.productTypeList.map((item) => (
                                                    <Option
                                                        key={item.productCode}
                                                        value={item.productCode}
                                                    >
                                                        {item.productName}
                                                    </Option>
                                                ))}
                                            </Select>
                                        </Form.Item>
                                    </Col>
                                    <Col span={4}>
                                        <Form.Item name="planCode">
                                            <Select allowClear placeholder="保障方案" size="small">
                                                {this.state.plans.map((item) => (
                                                    <Option
                                                        key={item.planCode}
                                                        value={item.planCode}
                                                    >
                                                        {item.planName}
                                                    </Option>
                                                ))}
                                            </Select>
                                        </Form.Item>
                                    </Col>
                                    <Col span={4}>
                                        <Form.Item name="claimState">
                                            <Select allowClear placeholder="核赔状态" size="small">
                                                <Option value="pending">待领取</Option>
                                                <Option value="checking">审核中</Option>
                                                <Option value="rejected">驳回</Option>
                                                <Option value="approved">已通过</Option>
                                            </Select>
                                        </Form.Item>
                                    </Col>
                                    <Col span={4}>
                                        <Form.Item name="syncStatus">
                                            <Select allowClear placeholder="提交保司" size="small">
                                                <Option key={'failure'} value={'failure'}>
                                                    提交失败
                                                </Option>
                                            </Select>
                                        </Form.Item>
                                    </Col>
                                    <Col span={4}>
                                        <Form.Item name="caseStatus">
                                            <Select
                                                allowClear
                                                placeholder="保司案件状态"
                                                size="small"
                                            >
                                                {this.state.YTCaseStatusList.map((item) => (
                                                    <Option key={item.value} value={item.value}>
                                                        {item.label}
                                                    </Option>
                                                ))}
                                            </Select>
                                        </Form.Item>
                                    </Col>
                                </React.Fragment>) : null
                            }
                            {[14].includes(tenantCode) ? (
                                <Col span={4}>
                                    <Form.Item name="productCode">
                                        <Select allowClear placeholder="产品类型" size="small">
                                            <Option key={'19G2'} value={'19G2'}>
                                                单车意外险
                                            </Option>
                                            <Option key={'19G3'} value={'19G3'}>
                                                助动车意外险
                                            </Option>
                                            {/* 新增选项 */}
                                            <Option key={'59G3'} value={'59G3'}>
                                                脚踏车 3 座
                                            </Option>
                                            <Option key={'59G4'} value={'59G4'}>
                                                脚踏车 4 座
                                            </Option>
                                            <Option key={'69G1'} value={'69G1'}>
                                                助力车 1 座
                                            </Option>
                                            <Option key={'69G3'} value={'69G3'}>
                                                助力车 3 座
                                            </Option>
                                            <Option key={'69G4'} value={'69G4'}>
                                                助力车 4 座
                                            </Option>
                                        </Select>
                                    </Form.Item>
                                </Col>
                            ) : null}
                            {/* 轮胎险 新增参数 */}
                            {[15].includes(tenantCode) ? (
                                <React.Fragment>
                                    <Col span={4}>
                                        <Form.Item name="tireDamageType">
                                            <Select allowClear placeholder="损伤类型" size="small">
                                                {this.state.reportTireDamageTypes.map(
                                                    (tireDamageType) => (
                                                        <Option
                                                            key={tireDamageType.value}
                                                            value={tireDamageType.value}
                                                        >
                                                            {tireDamageType.label}
                                                        </Option>
                                                    )
                                                )}
                                            </Select>
                                        </Form.Item>
                                    </Col>
                                    <Col span={4}>
                                        <Form.Item name="employerCompanyId">
                                            <Select allowClear placeholder="被保公司" size="small">
                                                {this.state.activeEmployer.map((item) => (
                                                    <Option
                                                        key={item.employerCompanyId}
                                                        value={item.employerCompanyId}
                                                    >
                                                        {item.companyName}
                                                    </Option>
                                                ))}
                                            </Select>
                                        </Form.Item>
                                    </Col>
                                    <Col span={4}>
                                        <Form.Item name="reporterCompanyId">
                                            <Select allowClear placeholder="报案公司" size="small">
                                                {this.state.activeEmployer.map((item) => (
                                                    <Option
                                                        key={item.employerCompanyId}
                                                        value={item.employerCompanyId}
                                                    >
                                                        {item.companyName}
                                                    </Option>
                                                ))}
                                            </Select>
                                        </Form.Item>
                                    </Col>
                                    <Col span={4}>
                                        <Form.Item name="policyOrderType">
                                            <Select allowClear placeholder="投保类型" size="small">
                                                {policyTypeList.map((item) => (
                                                    <Option key={item.value} value={item.value}>
                                                        {item.label}
                                                    </Option>
                                                ))}
                                            </Select>
                                        </Form.Item>
                                    </Col>
                                </React.Fragment>
                            ) : null}
                        </Row>
                    </Form>
                    <div className="search-wrap">
                        <div className="flex-center">
                            <Select
                                size="small"
                                className="kwTypeSelect"
                                value={query.kwType}
                                onChange={this.onChangeKwType}
                            >
                                {kwTypeOpts}
                            </Select>
                            <Search
                                placeholder="请输入内容"
                                enterButton="搜索"
                                size="small"
                                name="keyWord"
                                value={query.keyWord}
                                onChange={(e) =>
                                    this.setState({
                                        query: { ...query, [e.target.name]: e.target.value }
                                    })
                                }
                                style={{ width: 300, marginLeft: 4 }}
                                onSearch={this.onSearch}
                                disabled={this.state.loading}
                            />
                            <Button
                                onClick={this.resetSearchParams}
                                size="small"
                                style={{ margin: '0 0 0 6px', marginLeft: 6 }}
                            >
                                重置
                            </Button>
                        </div>
                        <div className="flex-center">


                            {currentAgent.permission.includes('expressMaterial') ? (
                                <Dropdown.Button
                                    onClick={this.downloadExpressMaterial}
                                    size="small"
                                    icon={<i className="iconfont icon-xiala" />}
                                    loading={this.state.isDownloadExpressMaterial}
                                    overlay={
                                        <Menu onClick={() => this.setState({ importExpressVisible: true })}>
                                            <Menu.Item key="assign-all">导入寄出包裹</Menu.Item>
                                        </Menu>
                                    }
                                    className="margin-left"
                                >
                                    导出邮寄清单
                                </Dropdown.Button>
                            ) : null}
                            {/* 
                                满足以下条件，显示按钮
                                1、公司管理员
                                2、前海饿了么租户，其他租户正式环境非生产环境可用
                            */}

                            {/* {accountAccess > 2 && ([21].includes(currentAgent.tenant.code) || isExport === 'true') && */}
                            {this.state.exportPermission ?
                                (
                                    <React.Fragment>
                                        <Button
                                            loading={this.state.isDownloadDetailFile}
                                            icon={<i className="iconfont icon-download" />}
                                            size="small"
                                            onClick={this.downloadReportDetailExcel}
                                            className="margin-left"
                                        >
                                            导出详情
                                        </Button>
                                        <Button
                                            loading={this.state.isDownloadFile}
                                            icon={<i className="iconfont icon-download" />}
                                            size="small"
                                            onClick={this.downloadExcel}
                                            className="margin-left"
                                        >
                                            导出列表
                                        </Button>
                                    </React.Fragment>
                                ) : null}

                            {/* {['2', '3'].includes(accountAccess) && */}
                            {
                                permission && permission.includes(DISPATCH_PERMISSION.REPORT_DISPATCH_COMPANY) ||
                                    permission && permission.includes(DISPATCH_PERMISSION.REPORT_DISPATCH_ORG)
                                    ?
                                    <Dropdown.Button
                                        //  disabled={
                                        //     this.state.selectedRowKeys &&
                                        //     this.state.selectedRowKeys.length < 1
                                        // }
                                        size="small"
                                        icon={<i className="iconfont icon-xiala" />}
                                        onClick={this.handleAssignSelected}
                                        overlay={<Menu onClick={this.handleAssign}>
                                            <Menu.Item key="assign-all">指派全部</Menu.Item>
                                            {
                                                accountAccess === '3' ? <Menu.Item key="import-assign">导入指派</Menu.Item> : null
                                            }
                                        </Menu>}
                                        style={{ marginLeft: 10 }}
                                    >
                                        指派
                                    </Dropdown.Button> : null
                            }
                        </div>
                    </div>
                </div>
                {pageState}
                <div className="Institution-name-bg">
                    <Table
                        rowKey="flowId"
                        loading={this.state.loading}
                        scroll={{ x: '110%', y: 560 }}
                        onChange={this.handleTableChange}
                        pagination={{
                            total: reportReceipts.count,
                            current: pageIndex,
                            pageSize: pageSize,
                            showTotal: (count) => `共 ${count} 条 `,
                            showSizeChanger: true,
                            pageSizeOptions: [10, 20, 50, 100]
                        }}
                        rowSelection={rowSelection}
                        columns={columns}
                        dataSource={reportsList}
                    />
                </div>

                <Drawer
                    title="更多筛选"
                    placement="right"
                    maskClosable={false}
                    onClose={this.closeMoreFilter}
                    visible={filterVisible}
                    className="drawer-filter"
                    extra={
                        <Space>
                            <Button onClick={this.searchMoreFilter} type="primary" size="small">
                                查询
                            </Button>
                            <Button onClick={this.resetSearchParams} size="small">
                                重置
                            </Button>
                        </Space>
                    }
                >
                    <Form
                        ref={this.filterForm}
                        labelCol={{ span: 8 }}
                        wrapperCol={{ span: 16 }}
                        labelAlign="left"
                        size="small"
                    >
                        <h2 className="filter-form-t">时间</h2>
                        <Form.Item name="daysType" style={{ display: 'none' }}>
                            <Input />
                        </Form.Item>
                        <Form.Item label="报案时间" name="createdDate">
                            <RangePicker onChange={this.changeCreatedTime} />
                        </Form.Item>
                        <Form.Item label="出险时间" name="accidentDate">
                            <RangePicker />
                        </Form.Item>
                        <Form.Item label="回访时间" name="clientReviewDate">
                            <RangePicker />
                        </Form.Item>
                        {[8].includes(currentAgent.tenant.code) ? (
                            <Form.Item label="预推时间" name="preCheckedDate">
                                <RangePicker />
                            </Form.Item>
                        ) : null}
                        <Form.Item label="已定损时间" name="checkedDate">
                            <RangePicker />
                        </Form.Item>
                        <Form.Item label="退票时间" name="refoundDate">
                            <RangePicker />
                        </Form.Item>
                        <Form.Item label="结案时间" name="finishedDate">
                            <RangePicker />
                        </Form.Item>
                        <Form.Item label="回访下次追踪" name="reviewNextDate">
                            <RangePicker />
                        </Form.Item>
                        <Form.Item label="处理人下次追踪" name="agentNextDate">
                            <RangePicker />
                        </Form.Item>
                        <Form.Item label="定损下次追踪" name="lossNextDate">
                            <RangePicker />
                        </Form.Item>
                        <Form.Item label="最新动态" name="topFollowDate">
                            <RangePicker />
                        </Form.Item>
                        {/* v2.0.0新增字段 */}
                        {/* 邮寄状态多选或未选择，邮寄状态时间字段置灰不可选 */}
                        <Form.Item shouldUpdate noStyle>
                            {({ getFieldValue }) => (
                                <Form.Item label="邮寄状态时间" name="expressMaterialStatusDate">
                                    <RangePicker
                                        disabled={
                                            !getFieldValue('expressMaterialStatus') ||
                                            getFieldValue('expressMaterialStatus')?.length === 0 ||
                                            getFieldValue('expressMaterialStatus')?.length > 1
                                        }
                                    />
                                </Form.Item>
                            )}
                        </Form.Item>

                        <Form.Item label="接收包裹时间" name="receivedExpressDate">
                            <RangePicker />
                        </Form.Item>

                        <h2 className="filter-form-t">金额</h2>
                        <Form.Item label="索赔金额">
                            <div className="flex-amount">
                                <Form.Item name="claimAmountMin">
                                    <InputNumber min={0} placeholder="最小金额" />
                                </Form.Item>
                                <span className="connector">-</span>
                                <Form.Item name="claimAmountMax">
                                    <InputNumber min={0} placeholder="最大金额" />
                                </Form.Item>
                            </div>
                        </Form.Item>
                        <Form.Item label="估损总金额">
                            <div className="flex-amount">
                                <Form.Item name="lossAssessmentAmountMin">
                                    <InputNumber min={0} placeholder="最小金额" />
                                </Form.Item>
                                <span className="connector">-</span>
                                <Form.Item name="lossAssessmentAmountMax">
                                    <InputNumber min={0} placeholder="最大金额" />
                                </Form.Item>
                            </div>
                        </Form.Item>
                        <Form.Item label="理赔总金额">
                            <div className="flex-amount">
                                <Form.Item name="claimAmountTotalMin">
                                    <InputNumber min={0} placeholder="最小金额" />
                                </Form.Item>
                                <span className="connector">-</span>
                                <Form.Item name="claimAmountTotalMax">
                                    <InputNumber min={0} placeholder="最大金额" />
                                </Form.Item>
                            </div>
                        </Form.Item>
                        <Form.Item label="打款总金额">
                            <div className="flex-amount">
                                <Form.Item name="caseAmountMin">
                                    <InputNumber min={0} placeholder="最小金额" />
                                </Form.Item>
                                <span className="connector">-</span>
                                <Form.Item name="caseAmountMax">
                                    <InputNumber min={0} placeholder="最大金额" />
                                </Form.Item>
                            </div>
                        </Form.Item>
                        <h2 className="filter-form-t">基本属性</h2>
                        <Form.Item name="searchOrgAccount" label="机构">
                            <Select
                                placeholder="请选择"
                                allowClear
                                onChange={this.changeSearchOrgAccount}
                                disabled={!overOrgQueryReportsPermission(currentAgent)}
                                mode="multiple"
                            >
                                {this.state.organization.map((item) => (
                                    <Option value={item._id} key={item._id}>
                                        {item.orgName}
                                    </Option>
                                ))}
                            </Select>
                        </Form.Item>
                        <Form.Item name="referer" label="渠道">
                            <Select allowClear placeholder="请选择">
                                {![21, 24, 25, 26, 27].includes(currentAgent.tenant.code) ? (
                                    <Option key="MINA" value="MINA">
                                        小程序
                                    </Option>
                                ) : null}
                                {[21].includes(currentAgent.tenant.code) ? (
                                    <Option key="CUSTOMER " value="CUSTOMER ">
                                        饿了么
                                    </Option>
                                ) : null}
                                {currentAgent.tenant.code === 8 ? (
                                    <Option key="ELEME" value="ELEME">
                                        饿了么
                                    </Option>
                                ) : null}
                                {![15, 24, 25, 26, 27].includes(currentAgent.tenant.code) ? (
                                    <Option key="AGENT" value="AGENT">
                                        坐席自建
                                    </Option>
                                ) : null}
                                {currentAgent.tenant.code === 13 ? (
                                    <Option key="YUANTONG" value="YUANTONG">
                                        圆通秒核
                                    </Option>
                                ) : null}
                                {[14, 19].includes(currentAgent.tenant.code) ? (
                                    <Option key="HALUO-H5" value="HALUO-H5">
                                        h5
                                    </Option>
                                ) : null}
                                {[20].includes(currentAgent.tenant.code) ? (
                                    <Option key="H5" value="H5">
                                        h5
                                    </Option>
                                ) : null}
                                {
                                    [17, 24].includes(tenantCode) ? (
                                        <Option key="DADA">达达平台</Option>
                                    ) : null
                                }
                                {
                                    [25, 26, 27].includes(tenantCode) ? (
                                        <Option key="QIANHAI2">前海</Option>
                                    ) : null
                                }
                            </Select>
                        </Form.Item>
                        <Form.Item label="工单状态" name="state">
                            <Select
                                placeholder="请选择"
                                mode="multiple"
                                allowClear
                                onChange={this.changeState}
                            >
                                {reportStateList.map((item) => (
                                    <Option key={item.value} value={item.value}>
                                        {item.label}
                                    </Option>
                                ))}
                            </Select>
                        </Form.Item>
                        <Form.Item
                            shouldUpdate={(prevValues, currentValues) =>
                                prevValues.state !== currentValues.state
                            }
                            noStyle
                        >
                            {({ getFieldValue }) => {
                                const state = getFieldValue('state');
                                return state && state.includes('finished') ? (
                                    <Form.Item name="subState" label="工单子状态">
                                        <Select placeholder="请选择" mode="multiple" allowClear>
                                            {finishedStateList.map((item) => (
                                                <Option key={item.value} value={item.value}>
                                                    {item.label}
                                                </Option>
                                            ))}
                                        </Select>
                                    </Form.Item>
                                ) : null;
                            }}
                        </Form.Item>
                        {![15, 19].includes(currentAgent.tenant.code) ? (
                            <React.Fragment>
                                <Form.Item name="defLossState" label="定损状态">
                                    <Select
                                        placeholder="请选择"
                                        mode="multiple"
                                        allowClear
                                        onChange={this.changeDefLossState}
                                    >
                                        {lossStateList.map((item) => (
                                            <Option key={item.value} value={item.value}>
                                                {item.label}
                                            </Option>
                                        ))}
                                    </Select>
                                </Form.Item>
                                <Form.Item
                                    shouldUpdate={(prevValues, currentValues) =>
                                        prevValues.defLossState !== currentValues.defLossState
                                    }
                                    noStyle
                                >
                                    {({ getFieldValue }) => {
                                        const defLossState = getFieldValue('defLossState');
                                        return defLossState && defLossState.includes('checking') ? (
                                            <Form.Item name="defLossSubState" label="定损子状态">
                                                <Select placeholder="请选择" allowClear>
                                                    {lossSubStateList.map((item) => (
                                                        <Option key={item.value} value={item.value}>
                                                            {item.label}
                                                        </Option>
                                                    ))}
                                                </Select>
                                            </Form.Item>
                                        ) : null;
                                    }}
                                </Form.Item>
                                {/* 邮寄状态 */}

                                <Form.Item name="expressMaterialStatus" label="邮寄状态">
                                    <Select mode="multiple" placeholder="邮寄状态" size="small">
                                        <Option value="toCheck" key="toCheck">
                                            邮寄审核
                                        </Option>
                                        <Option value="returned" key="returned">
                                            邮寄退回
                                        </Option>
                                        <Option value="added" key="added">
                                            邮寄补充
                                        </Option>
                                        <Option value="toPost" key="toPost">
                                            待邮寄
                                        </Option>
                                        <Option value="posted" key="posted">
                                            已邮寄
                                        </Option>
                                    </Select>
                                </Form.Item>

                                <Form.Item name="accidentFirstType" label="单方/多方">
                                    <Select placeholder="请选择" allowClear>
                                        {accidentFirstTypeList.map((item) => (
                                            <Option value={item.value} key={item.value}>
                                                {item.label}
                                            </Option>
                                        ))}
                                    </Select>
                                </Form.Item>
                                {/* 查询损失类型 */}
                                <Form.Item name="accidentSecondType" label="损失类型">
                                    <Select allowClear placeholder="请选择">
                                        {accidentSecondTypeList.map((item) => (
                                            <Option value={item.value} key={item.value}>
                                                {item.label}
                                            </Option>
                                        ))}
                                    </Select>
                                </Form.Item>
                            </React.Fragment>
                        ) : null}
                        <Form.Item name="agentId" label="当前处理人">
                            {/* <Select
                                showSearch
                                optionFilterProp="children"
                                notFoundContent="无法找到"
                                placeholder="请选择"
                            >
                                {agentOptArr}
                            </Select> */}
                            <RemoteSearchSelect
                                allowClear
                                size="small"
                                placeholder="处理人"
                                url="/api/agents/simple"
                                paramName="searchStr"
                                fieldName="agents"
                                textName="fullName"
                                valueName="_id"
                                query={`&searchOrgAccount=${(values && values.searchOrgAccount) || ''
                                    }&searchTenant=${(values && values.searchTenant) || ''
                                    }&getRole=true`}
                                pageSize={1000}
                                ref={(RemoteSearchSelectAgentId) =>
                                    (this.RemoteSearchSelectAgentId = RemoteSearchSelectAgentId)
                                }
                                filter={'(agent) => agent.agentRole && agent.agentRole.isSurvey'}
                            />
                        </Form.Item>
                        <Form.Item name="customerAgentId" label="资料坐席">
                            {/* <Select
                                showSearch
                                optionFilterProp="children"
                                notFoundContent="无法找到"
                                placeholder="请选择"
                            >
                                <Option value="" key="">
                                    资料坐席
                                </Option>
                                {agentOpts}
                                
                            </Select> */}

                            <RemoteSearchSelect
                                allowClear
                                size="small"
                                placeholder="资料坐席"
                                url="/api/agents/simple"
                                paramName="searchStr"
                                fieldName="agents"
                                textName="fullName"
                                valueName="_id"
                                query={`&searchOrgAccount=${(values && values.searchOrgAccount) || ''
                                    }&searchTenant=${(values && values.searchTenant) || ''
                                    }&getRole=true`}
                                pageSize={1000}
                                ref={(RemoteSearchSelectCustomerAgentId) =>
                                (this.RemoteSearchSelectCustomerAgentId =
                                    RemoteSearchSelectCustomerAgentId)
                                }
                                filter={'(agent) => agent.agentRole && agent.agentRole.isSurvey'}
                            />
                        </Form.Item>
                        <Form.Item name="clientReviewAgentId" label="回访坐席">
                            {/* <Select
                                showSearch
                                optionFilterProp="children"
                                notFoundContent="无法找到"
                                placeholder="请选择"
                            >
                                <Option value="" key="">
                                    回访坐席
                                </Option>
                                {agentOpts}
                            </Select> */}
                            <RemoteSearchSelect
                                allowClear
                                size="small"
                                placeholder="回访坐席"
                                url="/api/agents/simple"
                                paramName="searchStr"
                                fieldName="agents"
                                textName="fullName"
                                valueName="_id"
                                query={`&searchOrgAccount=${(values && values.searchOrgAccount) || ''
                                    }&searchTenant=${(values && values.searchTenant) || ''
                                    }&getRole=true`}
                                pageSize={1000}
                                ref={(RemoteSearchSelectClientReviewAgentId) =>
                                (this.RemoteSearchSelectClientReviewAgentId =
                                    RemoteSearchSelectClientReviewAgentId)
                                }
                                filter={'(agent) => agent.agentRole && agent.agentRole.isSurvey'}
                            />
                        </Form.Item>
                        {![15, 19].includes(currentAgent.tenant.code) ? (
                            <Form.Item name="defLossAgentId" label="定损坐席">
                                <RemoteSearchSelect
                                    allowClear
                                    size="small"
                                    placeholder="全部定损坐席"
                                    url="/api/agents/simple"
                                    paramName="searchStr"
                                    fieldName="agents"
                                    textName="fullName"
                                    valueName="_id"
                                    query={`&searchOrgAccount=${(values && values.searchOrgAccount) || ''
                                        }&searchTenant=${(values && values.searchTenant) || ''
                                        }&getRole=true`}
                                    pageSize={1000}
                                    ref={(RemoteSearchSelectDefLossAgentId) =>
                                    (this.RemoteSearchSelectDefLossAgentId =
                                        RemoteSearchSelectDefLossAgentId)
                                    }
                                    filter={
                                        '(agent) => agent.agentRole && agent.agentRole.isSurvey'
                                    }
                                />
                            </Form.Item>
                        ) : null}
                        {![17, 18, 19, 20].includes(currentAgent.tenant.code) ? (
                            <Form.Item name="coreProductCodes" label="险种">
                                <Select allowClear placeholder="请选择" mode="multiple">
                                    {this.state.riskTypes.map((riskType) => (
                                        <Option
                                            key={riskType.coreProductCode}
                                            value={riskType.coreProductCode}
                                        >
                                            {riskType.coreProductName}
                                        </Option>
                                    ))}
                                </Select>
                            </Form.Item>
                        ) : null}
                        {[13, 17, 24, 25, 26, 27].includes(currentAgent.tenant.code) ? (
                            <Form.Item name="planCode" label="保障方案">
                                <Select allowClear placeholder="请选择">
                                    {this.state.plans.map((item) => (
                                        <Option key={item.planCode} value={item.planCode}>
                                            {item.planName}
                                        </Option>
                                    ))}
                                </Select>
                            </Form.Item>
                        ) : null}

                        {[24, 25, 26, 27].includes(tenantCode) ? (
                            <Form.Item name="productCode" label="产品类型">
                                <Select allowClear placeholder="产品类型" size="small">
                                    {this.state.riskProducts.map((item) => (
                                        <Option value={item.productCode} key={item.productCode}>
                                            {item.productName}
                                        </Option>
                                    ))}
                                </Select>
                            </Form.Item>
                        ) : null}
                        <h2 className="filter-form-t">其他</h2>
                        <Form.Item name="accidentProvinceName" label="出险省份">
                            <Select placeholder="请选择" allowClear>
                                {provinceList.map((item) => (
                                    <Option value={item.value} key={item.value}>
                                        {item.label}
                                    </Option>
                                ))}
                            </Select>
                        </Form.Item>
                        <Form.Item name="isLostContactCsr" label="是否失联">
                            <Select placeholder="请选择" allowClear>
                                <Option key={0} value={0}>
                                    未失联
                                </Option>
                                <Option key={1} value={1}>
                                    失联
                                </Option>
                            </Select>
                        </Form.Item>
                        <Form.Item name="majorCaseType" label="案件类型">
                            <Select placeholder="请选择" mode="multiple">
                                <Option key='NORMAL' value='NORMAL'>
                                    常规案
                                </Option>
                                {this.state.majorCaseTypes.map((item) => (
                                    <Option key={item.value} value={item.value}>
                                        {item.label}
                                    </Option>
                                ))}
                            </Select>
                        </Form.Item>

                        {![18, 19, 20].includes(currentAgent.tenant.code) ? (
                            <Form.Item name="clientReview" label="是否回访">
                                <Select allowClear placeholder="请选择">
                                    <Option value="0">未回访</Option>
                                    <Option value="2">回访完成</Option>
                                    <Option value="1">回访未接</Option>
                                </Select>
                            </Form.Item>
                        ) : null}
                        <Form.Item name="coopTaskTypes" label="是否协作">
                            <Select placeholder="请选择" allowClear mode="multiple">
                                {coopTaskTypeList.map((item) => (
                                    <Option value={item.value} key={item.value}>
                                        {item.label}
                                    </Option>
                                ))}
                            </Select>
                        </Form.Item>
                        <Form.Item name="complaintLevels" label="是否投诉">
                            <Select placeholder="请选择" mode="multiple" allowClear>
                                {complaintLevelList.map((item) => (
                                    <Option value={item.value} key={item.value}>
                                        {item.label}
                                    </Option>
                                ))}
                            </Select>
                        </Form.Item>
                        {![14, 19].includes(currentAgent.tenant.code) ? (
                            <Form.Item name="surveyType" label="是否视频定损">
                                <Select placeholder="请选择" allowClear>
                                    <Option value="1">视频定损</Option>
                                    <Option value="0">非视频定损</Option>
                                </Select>
                            </Form.Item>
                        ) : null}
                        {[8].includes(currentAgent.tenant.code) ? (
                            <Form.Item name="elemeAuditStatus" label="饿了么状态">
                                <Select placeholder="请选择" allowClear>
                                    {elemeAuditStatusList.map((item) => (
                                        <Option key={item.value} value={item.value}>
                                            {item.label}
                                        </Option>
                                    ))}
                                </Select>
                            </Form.Item>
                        ) : null}
                        {/* 前海饿了么 */}
                        {[21].includes(currentAgent.tenant.code) ? (
                            <Form.Item name="elemeAuditStatus" label="饿了么状态">
                                <Select placeholder="请选择" allowClear>
                                    {QIANHAIelemeAuditStatusList.map((item) => (
                                        <Option key={item.value} value={item.value}>
                                            {item.label}
                                        </Option>
                                    ))}
                                </Select>
                            </Form.Item>
                        ) : null}
                        <Form.Item name="riskLevelId" label="风险等级">
                            <Select allowClear placeholder="请选择" mode="multiple">
                                {this.state.levels.map((item) => (
                                    <Option key={item.levelId} value={item.levelId}>
                                        {item.levelName}
                                    </Option>
                                ))}
                            </Select>
                        </Form.Item>
                        {![15, 19].includes(currentAgent.tenant.code) ? (
                            <Form.Item name="casualty" label="人伤情况">
                                <Select allowClear placeholder="请选择">
                                    {casualtyList.map((item) => (
                                        <Option key={item.value} value={item.value}>
                                            {item.label}
                                        </Option>
                                    ))}
                                </Select>
                            </Form.Item>
                        ) : null}
                        {[8].includes(currentAgent.tenant.code) ? (
                            <Form.Item name="surveyMethod" label="是否线下查勘">
                                <Select allowClear placeholder="请选择">
                                    <Option key="OFFLINE_SURVEY" value="OFFLINE_SURVEY">
                                        线下查勘
                                    </Option>
                                    <Option key="ONLINE_SURVEY" value="ONLINE_SURVEY">
                                        线上查勘
                                    </Option>
                                </Select>
                            </Form.Item>
                        ) : null}
                        <Form.Item name="relateComplaint" label="是否诉讼">
                            <Select placeholder="请选择" allowClear>
                                <Option value={true} key={true}>
                                    是
                                </Option>
                                <Option value={false} key={false}>
                                    否
                                </Option>
                            </Select>
                        </Form.Item>
                        {[8].includes(currentAgent.tenant.code) ? (
                            <React.Fragment>
                                <Form.Item name="insuranceResp" label="保险责任">
                                    <Select allowClear placeholder="请选择">
                                        <Option key="0" value="0">
                                            责任内
                                        </Option>
                                        <Option key="1" value="1">
                                            责任外
                                        </Option>
                                    </Select>
                                </Form.Item>
                                <Form.Item name="transport" label="运力线">
                                    <Select placeholder="请选择" allowClear>
                                        <Option value="1" key="1">
                                            专送
                                        </Option>
                                        <Option value="2" key="2">
                                            城代
                                        </Option>
                                        <Option value="3" key="3">
                                            众包
                                        </Option>
                                    </Select>
                                </Form.Item>
                            </React.Fragment>
                        ) : null}
                        <Form.Item name="policyStatus" label="保单情况">
                            <Select allowClear placeholder="请选择">
                                <Option key="2" value="2">
                                    无保单
                                </Option>
                            </Select>
                        </Form.Item>
                        <Form.Item name="wholeCoopTaskStatus" label="整案核赔">
                            <Select placeholder="请选择" mode="multiple" allowClear>
                                <Option value="none" key="none">
                                    无核赔
                                </Option>
                                <Option value="dealing" key="dealing">
                                    核赔中
                                </Option>
                                <Option value="completed" key="completed">
                                    核赔完成
                                </Option>
                            </Select>
                        </Form.Item>
                        <Form.Item name="recommendChecked" label="核赔推荐">
                            <Select placeholder="请选择" allowClear>
                                <Option value="1" key="1">
                                    核赔推荐
                                </Option>
                            </Select>
                        </Form.Item>
                        <Form.Item name="recommendWithdraw" label="撤案推荐">
                            <Select placeholder="请选择" mode="multiple" allowClear>
                                {recommendWithdrawStatusOptions.map((item) => (
                                    <Option value={item.value} key={item.value}>
                                        {item.label}
                                    </Option>
                                ))}
                            </Select>
                        </Form.Item>
                        <Form.Item label="就诊医院" name="hospital">
                            <Input placeholder="请输入" />
                        </Form.Item>
                        <Form.Item label="维修机构" name="carRepairOrg">
                            <Input placeholder="请输入" />
                        </Form.Item>
                        {/* v1.7.6新增字段 */}
                        <Form.Item label="三者姓名" name="otherCarOwner">
                            <Input placeholder="请输入" />
                        </Form.Item>
                        <Form.Item label="三者车牌号" name="otherCarNum">
                            <Input placeholder="请输入" />
                        </Form.Item>
                        {/* v2.0.0新增字段 */}
                        <Form.Item label="三者证件号" name="otherCardNum">
                            <Input placeholder="请输入" />
                        </Form.Item>
                    </Form>
                </Drawer>

                {/* 导入寄出包裹 */}
                <ImportExpressPackages visible={importExpressVisible} onCancel={() => this.setState({ importExpressVisible: false })} />
                {/* 导入指派案件 */}
                <ImportAssignmentReport visible={importAssignmentVisible} onCancel={() => this.setState({ importAssignmentVisible: false })} callback={this.handleAssignFileCallback} />
                {/* 指派 */}
                <Modal
                    visible={this.state.assignModalVisible}
                    title="请选择要指派的坐席"
                    maskClosable={false}
                    wrapClassName="assign-agent-modal"
                    onCancel={this.handleCancelAssignModal}
                    width={'60%'}
                    footer={<div className="flex-center">
                        {
                            this.state.assignType === 'assign' ? <span>
                                已选择{this.state.selectedRowKeys.length}个工单准备指派
                            </span> : <span>
                                已选择{assignInfo.reportCount}个工单准备指派
                            </span>
                        }
                        <div>
                            <Button
                                key="back"
                                style={{ marginRight: 10 }}
                                onClick={this.handleCancelAssignModal}
                                size="small"
                            >
                                取消
                            </Button>
                            {
                                this.state.assignType === 'assign' ? <Button
                                    disabled={assignDisabled}
                                    key="submit"
                                    type="primary"
                                    loading={this.state.assignReportLoading}
                                    onClick={this.handleAssignOk}
                                    size="small"
                                >
                                    确定指派
                                </Button> : null
                            }

                            {
                                this.state.assignType === 'assignAll' ? <Button
                                    disabled={assignDisabled}
                                    key="submit"
                                    type="primary"
                                    loading={this.state.assignReportLoading}
                                    onClick={this.handleAssignAllOk}
                                    size="small"
                                >
                                    确定指派
                                </Button> : null
                            }

                            {
                                this.state.assignType === 'assignByFile' ? <Button
                                    disabled={assignDisabled}
                                    key="submit"
                                    type="primary"
                                    loading={this.state.assignReportLoading}
                                    onClick={this.handleAssignByFile}
                                    size="small"
                                >
                                    确定指派
                                </Button> : null
                            }
                        </div>
                    </div>
                    }
                >
                    <div className="flex-center margin-bottom">
                        <div>
                            {
                                this.state.assignType === 'assign' ? <span>包含{selectedRows.length}个工单，{selectedRows.filter((item) => item.hasDefLossTask).length}个定损任务</span> : null
                            }
                            {
                                ['assignAll', 'assignByFile'].includes(this.state.assignType) ? <span>包含{assignInfo.reportCount}个工单，{assignInfo.defLossTaskCount}个定损任务</span> : null
                            }
                        </div>
                        <div>
                            <span>选择任务类型：</span>
                            {/* 选择了不同机构的案件，或者将案件跨机构指派，则不能操作 */}
                            <Checkbox.Group
                                options={[
                                    { label: '常规工单', value: 1 },
                                    { label: '定损任务', value: 2 }
                                ]}
                                onChange={this.onChangeCheckbox}
                                value={selectedAssignmentInfo.selectedTypes}
                                disabled={diffAccount.length > 1 || (diffAccount[0] !== selectedAssignmentInfo.selectedOrgId && selectedAssignmentInfo.selectedOrgId)}
                            />
                        </div>
                    </div>
                    <div className="margin-bottom">
                        <span>选择指派机构：</span>
                        <Select
                            allowClear
                            value={selectedAssignmentInfo.selectedOrgId}
                            placeholder="请选择"
                            style={{ width: '30%' }}
                            onChange={this.handleChangeOrgAccount}
                            // disabled={accountAccess === '2' && permission.includes('reportDispatchCompany')}
                            disabled={!permission.includes(DISPATCH_PERMISSION.REPORT_DISPATCH_COMPANY)}
                        >
                            {this.state.organization.map((item) => (
                                <Option key={item._id} value={item._id}>
                                    {item.orgName}
                                </Option>
                            ))}
                        </Select>
                        <Input
                            placeholder="搜索坐席姓名"
                            style={{
                                height: '32px',
                                width: '46%',
                                marginLeft: 20
                            }}
                            prefix={
                                <i
                                    className="iconfont icon-search"
                                    style={{ color: 'rgba(0,0,0,.25)' }}
                                />
                            }
                            onChange={this.onChangeAssignedName}
                            disabled={!selectedAssignmentInfo.selectedOrgId}
                        />
                    </div>
                    <div className="assign-agent-list">
                        <Collapse>
                            {assignableAgents.map((item) => (
                                <Collapse.Panel
                                    header={item.name ? item.name : ''}
                                    key={item._id}
                                >
                                    {item.agents && item.agents.length
                                        ? item.agents.map((agent) => {
                                            const agentStatusName =
                                                agentStatusNames[agent.agentStatus] || '未知';
                                            const agentStatusStyle =
                                                agentStatusCalssNames[agent.agentStatus] ||
                                                agentStatusCalssNames['off'];
                                            return (
                                                <div
                                                    key={agent._id}
                                                    className="assign-agent-li"
                                                >
                                                    <Radio name="assign-agent" checked={selectedAssignmentInfo.selectedAgentId == agent._id} onClick={() => this.handleAssignToAgent(agent._id)} />
                                                    <span className="agent-info-span">{`${agent.loginName}(${agent.fullName})`}</span>
                                                    <span className={agentStatusStyle}>
                                                        {agentStatusName}
                                                    </span>
                                                </div>
                                            );
                                        })
                                        : null}
                                </Collapse.Panel>
                            ))}
                        </Collapse>
                        <div style={{ padding: '10px 16px' }}>
                            {/* 显示客服组外的坐席 */}
                            {outsideAgents.map((agent) => {
                                const agentStatusName = agentStatusNames[agent.agentStatus] || '未知';
                                const agentStatusStyle =
                                    agentStatusCalssNames[agent.agentStatus] ||
                                    agentStatusCalssNames['off'];
                                return (
                                    <div key={agent._id} className="assign-agent-li">
                                        <Radio name="assign-agent" checked={selectedAssignmentInfo.selectedAgentId == agent._id} onClick={() => this.handleAssignToAgent(agent._id)} />
                                        <span className="agent-info-span">{`${agent.loginName}(${agent.fullName})`}</span>
                                        <span className={agentStatusStyle}>{agentStatusName}</span>
                                    </div>
                                );
                            })}
                        </div>
                        {[...assignableAgents, ...outsideAgents].length === 0 && (
                            <div className="no-agent-tip">暂无可指派坐席</div>
                        )}
                    </div>
                </Modal>
            </div>
        );
    }
}
let mapStateToProps = (state) => {
    return {
        company: state.company,
        currentAgent: state.app.currentAgent.userInfo
    };
};
let mapDispatchToProps = (dispatch) => {
    return {
        actions: bindActionCreators(
            Object.assign({}, report, lossAssDashboard, reportPreviewActions, agentActions),
            dispatch
        )
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(ReportPage);
